import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Slide, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getEnumValue } from "brancy/helper/handleItemTypeEnum";
import { LanguageKey } from "brancy/i18n";
const getResponseTextLegacy = (responseType: ResponseType): string => {
  const responseTextMap: Record<ResponseType, LanguageKey> = {
    [ResponseType.Ok]: LanguageKey.Notify_Ok,
    [ResponseType.InternalException]: LanguageKey.Notify_InternalException,
    [ResponseType.CannotSendSmsNow]: LanguageKey.Notify_CannotSendSmsNow,
    [ResponseType.InvalidPhoneNumber]: LanguageKey.Notify_InvalidPhoneNumber,
    [ResponseType.InvalidCountryCode]: LanguageKey.Notify_InvalidCountryCode,
    [ResponseType.PhoneNumberNotAvailableInThisCountry]: LanguageKey.Notify_PhoneNumberNotAvailableInThisCountry,
    [ResponseType.InstagramerIdNotExist]: LanguageKey.Notify_InstagramerIdNotExist,
    [ResponseType.EmptyProductList]: LanguageKey.Notify_EmptyProductList,
    [ResponseType.InvalidVerificationCode]: LanguageKey.Notify_InvalidVerificationCode,
    [ResponseType.LowQuality]: LanguageKey.Notify_LowQuality,
    [ResponseType.CannotEmptyChildren]: LanguageKey.Notify_CannotEmptyChildren,
    [ResponseType.InvalidAspectRatio]: LanguageKey.Notify_InvalidAspectRatio,
    [ResponseType.InvalidMediaCodec]: LanguageKey.Notify_InvalidMediaCodec,
    [ResponseType.InvalidMediaType]: LanguageKey.Notify_InvalidMediaType,
    [ResponseType.MediaUrlNotAccessible]: LanguageKey.Notify_MediaUrlNotAccessible,
    [ResponseType.CannotCreatePrePostNow]: LanguageKey.Notify_CannotCreatePrePostNow,
    [ResponseType.InvalidMediaContent]: LanguageKey.Notify_InvalidMediaContent,
    [ResponseType.Unexpected]: LanguageKey.Notify_Unexpected,
    [ResponseType.TooManyRequestForImageHashtagGenerator]: LanguageKey.Notify_TooManyRequestForImageHashtagGenerator,
    [ResponseType.LoginFailed]: LanguageKey.Notify_LoginFailed,
    [ResponseType.NullUserId]: LanguageKey.Notify_NullUserId,
    [ResponseType.RealtimeSocketNotExist]: LanguageKey.Notify_RealtimeSocketNotExist,
    [ResponseType.PushSocketNotExist]: LanguageKey.Notify_PushSocketNotExist,
    [ResponseType.InstaApiNotFoundForConnect]: LanguageKey.Notify_InstaApiNotFoundForConnect,
    [ResponseType.EmptyHashtagList]: LanguageKey.Notify_EmptyHashtagList,
    [ResponseType.InvalidHashtagListId]: LanguageKey.Notify_InvalidHashtagListId,
    [ResponseType.DeleteHashtagFail]: LanguageKey.Notify_DeleteHashtagFail,
    [ResponseType.InvalidBase64Content]: LanguageKey.Notify_InvalidBase64Content,
    [ResponseType.InvalidTermsAndConditionSvgType]: LanguageKey.Notify_InvalidTermsAndConditionSvgType,
    [ResponseType.InvalidLotteryAnnouncementBannerId]: LanguageKey.Notify_InvalidLotteryAnnouncementBannerId,
    [ResponseType.InvalidLotteryAnnouncementBannerStr]: LanguageKey.Notify_InvalidLotteryAnnouncementBannerStr,
    [ResponseType.InvalidPostId]: LanguageKey.Notify_InvalidPostId,
    [ResponseType.TooSoonLotteryInfo]: LanguageKey.Notify_TooSoonLotteryInfo,
    [ResponseType.InvalidDirectParams]: LanguageKey.Notify_InvalidDirectParams,
    [ResponseType.NoInstagramerExists]: LanguageKey.Notify_NoInstagramerExists,
    [ResponseType.PropertyNotFoundOrNull]: LanguageKey.Notify_PropertyNotFoundOrNull,
    [ResponseType.ReachNumberOfPinDirect]: LanguageKey.Notify_ReachNumberOfPinDirect,
    [ResponseType.InvalidStoryId]: LanguageKey.Notify_InvalidStoryId,
    [ResponseType.MaxPrePostReach]: LanguageKey.Notify_MaxPrePostReach,
    [ResponseType.InvalidDraftId]: LanguageKey.Notify_InvalidDraftId,
    [ResponseType.InvalidPrePostId]: LanguageKey.Notify_InvalidPrePostId,
    [ResponseType.ReachHashtagListLimit]: LanguageKey.Notify_ReachHashtagListLimit,
    [ResponseType.EmptyUsername]: LanguageKey.Notify_EmptyUsername,
    [ResponseType.TooManyRequestForPageHashtagAnalysis]: LanguageKey.Notify_TooManyRequestForPageHashtagAnalysis,
    [ResponseType.PasswordRequired]: LanguageKey.Notify_PasswordRequired,
    [ResponseType.PackageRequiredInThisTime]: LanguageKey.Notify_PackageRequiredInThisTime,
    [ResponseType.FeatureRequiredInThisTime]: LanguageKey.Notify_FeatureRequiredInThisTime,
    [ResponseType.NoShopperExist]: LanguageKey.Notify_NoShopperExist,
    [ResponseType.FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount]:
      LanguageKey.Notify_FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount,
    [ResponseType.FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount]:
      LanguageKey.Notify_FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount,
    [ResponseType.InvalidLinkId]: LanguageKey.Notify_InvalidLinkId,
    [ResponseType.ReachMaxBioLink]: LanguageKey.Notify_ReachMaxBioLink,
    [ResponseType.OnlyBusinessAccountHasThisAccess]: LanguageKey.Notify_OnlyBusinessAccountHasThisAccess,
    [ResponseType.NoYoutubeChannelFound]: LanguageKey.Notify_NoYoutubeChannelFound,
    [ResponseType.CannotGetYoutubeRightNow]: LanguageKey.Notify_CannotGetYoutubeRightNow,
    [ResponseType.AparatUsernameNotFound]: LanguageKey.Notify_AparatUsernameNotFound,
    [ResponseType.AparatChannelHasNotAnyVideo]: LanguageKey.Notify_AparatChannelHasNotAnyVideo,
    [ResponseType.InvalidYoutubeChannelId]: LanguageKey.Notify_InvalidYoutubeChannelId,
    [ResponseType.NoAparatChannelFound]: LanguageKey.Notify_NoAparatChannelFound,
    [ResponseType.CannotGetAparatRightNow]: LanguageKey.Notify_CannotGetAparatRightNow,
    [ResponseType.NotSettedCustomDomain]: LanguageKey.Notify_NotSettedCustomDomain,
    [ResponseType.CannotStoryWithoutWinnerBanner]: LanguageKey.Notify_CannotStoryWithoutWinnerBanner,
    [ResponseType.ExceedMaxStoryWinnerLotteryBanner]: LanguageKey.Notify_ExceedMaxStoryWinnerLotteryBanner,
    [ResponseType.LotteryOnProcessingOrEnded]: LanguageKey.Notify_LotteryOnProcessingOrEnded,
    [ResponseType.CannotAbortLotteryOneHourBefore]: LanguageKey.Notify_CannotAbortLotteryOneHourBefore,
    [ResponseType.CannotAbortFollowerLottery]: LanguageKey.Notify_CannotAbortFollowerLottery,
    [ResponseType.InvalidImageOrExceedMaxSize]: LanguageKey.Notify_InvalidImageOrExceedMaxSize,
    [ResponseType.ExceedLoginAttempt]: LanguageKey.Notify_ExceedLoginAttempt,
    [ResponseType.NotExistComment]: LanguageKey.Notify_NotExistComment,
    [ResponseType.UserNotFound]: LanguageKey.Notify_UserNotFound,
    [ResponseType.ExistInstagramerBefore]: LanguageKey.Notify_ExistInstagramerBefore,
    [ResponseType.CannotChangeBusinessAccountType]: LanguageKey.Notify_CannotChangeBusinessAccountType,
    [ResponseType.InvalidProductId]: LanguageKey.Notify_InvalidProductId,
    [ResponseType.InvalidTrendHashtagPeriod]: LanguageKey.Notify_InvalidTrendHashtagPeriod,
    [ResponseType.InvalidLanguageId]: LanguageKey.Notify_InvalidLanguageId,
    [ResponseType.CannotStoryWithoutTermsBanner]: LanguageKey.Notify_CannotStoryWithoutTermsBanner,
    [ResponseType.ExceedMaxStoryTermsLotteryBanner]: LanguageKey.Notify_ExceedMaxStoryTermsLotteryBanner,
    [ResponseType.LotteryTermsIsNull]: LanguageKey.Notify_LotteryTermsIsNull,
    [ResponseType.CanShareTermsBefore6HoursOfStartLottery]: LanguageKey.Notify_CanShareTermsBefore6HoursOfStartLottery,
    [ResponseType.CanShareTermForOnlyDefinedStatusLotteries]:
      LanguageKey.Notify_CanShareTermForOnlyDefinedStatusLotteries,
    [ResponseType.SharedRemainingTimeBefore]: LanguageKey.Notify_SharedRemainingTimeBefore,
    [ResponseType.ShareRemainingTimeOnlyActiveForScoreLottery]:
      LanguageKey.Notify_ShareRemainingTimeOnlyActiveForScoreLottery,
    [ResponseType.CanShareTermsBefore1HoursOfStartLottery]: LanguageKey.Notify_CanShareTermsBefore1HoursOfStartLottery,
    [ResponseType.InvalidSubProductIds]: LanguageKey.Notify_InvalidSubProductIds,
    [ResponseType.ReachMaxProductMedia]: LanguageKey.Notify_ReachMaxProductMedia,
    [ResponseType.InvalidMediaProductId]: LanguageKey.Notify_InvalidMediaProductId,
    [ResponseType.AccountNotABusiness]: LanguageKey.Notify_AccountNotABusiness,
    [ResponseType.NotFoundProductWithThisTempId]: LanguageKey.Notify_NotFoundProductWithThisTempId,
    [ResponseType.InvalidAvailabilityStatus]: LanguageKey.Notify_InvalidAvailabilityStatus,
    [ResponseType.InvalidIbanNumber]: LanguageKey.Notify_InvalidIbanNumber,
    [ResponseType.ExistedIbanNumber]: LanguageKey.Notify_ExistedIbanNumber,
    [ResponseType.IbanMethodNotAvailableForNotTomanPriceUser]:
      LanguageKey.Notify_IbanMethodNotAvailableForNotTomanPriceUser,
    [ResponseType.SearchQueryIsEmpty]: LanguageKey.Notify_SearchQueryIsEmpty,
    [ResponseType.ExceedMaxInEachCard]: LanguageKey.Notify_ExceedMaxInEachCard,
    [ResponseType.ProductNotAlbumPost]: LanguageKey.Notify_ProductNotAlbumPost,
    [ResponseType.InvalidChildrenId]: LanguageKey.Notify_InvalidChildrenId,
    [ResponseType.NotAvailableProduct]: LanguageKey.Notify_NotAvailableProduct,
    [ResponseType.ExceedStockCount]: LanguageKey.Notify_ExceedStockCount,
    [ResponseType.CannotUnloadAnInstanceProduct]: LanguageKey.Notify_CannotUnloadAnInstanceProduct,
    [ResponseType.InvalidCategoryId]: LanguageKey.Notify_InvalidCategoryId,
    [ResponseType.NotFoundAnyProductOnThisCategory]: LanguageKey.Notify_NotFoundAnyProductOnThisCategory,
    [ResponseType.NotFoundAnyNextProduct]: LanguageKey.Notify_NotFoundAnyNextProduct,
    [ResponseType.NotFoundAnyPreviousProduct]: LanguageKey.Notify_NotFoundAnyPreviousProduct,
    [ResponseType.InvalidItemId]: LanguageKey.Notify_InvalidItemId,
    [ResponseType.IpInvalid]: LanguageKey.Notify_IpInvalid,
    [ResponseType.ThisInstagramAccountAddedBefore]: LanguageKey.Notify_ThisInstagramAccountAddedBefore,
    [ResponseType.InvalidTicketId]: LanguageKey.Notify_InvalidTicketId,
    [ResponseType.ExpiredSignature]: LanguageKey.Notify_ExpiredSignature,
    [ResponseType.Forbidden]: LanguageKey.Notify_Forbidden,
    [ResponseType.ConnectedInstagramPageNotFound]: LanguageKey.Notify_ConnectedInstagramPageNotFound,
    [ResponseType.AllInstagramAccountConnectedAddedBefore]: LanguageKey.Notify_AllInstagramAccountConnectedAddedBefore,
    [ResponseType.SelectInstagramPageToConnect]: LanguageKey.Notify_SelectInstagramPageToConnect,
    [ResponseType.InstagramRedirectRoleNotFound]: LanguageKey.Notify_InstagramRedirectRoleNotFound,
    [ResponseType.FacebookLoginNotFound]: LanguageKey.Notify_FacebookLoginNotFound,
    [ResponseType.SelectedPageNotFound]: LanguageKey.Notify_SelectedPageNotFound,
    [ResponseType.ShouldConnectInstaPageAgain]: LanguageKey.Notify_ShouldConnectInstaPageAgain,
    [ResponseType.InvalidProductSuggestionId]: LanguageKey.Notify_InvalidProductSuggestionId,
    [ResponseType.NotSavedSuggestions]: LanguageKey.Notify_NotSavedSuggestions,
    [ResponseType.ExistedSuggestedMedia]: LanguageKey.Notify_ExistedSuggestedMedia,
    [ResponseType.InvalidUploadMediaUrl]: LanguageKey.Notify_InvalidUploadMediaUrl,
    [ResponseType.SuggestedPostAutoReplyKeyNotExist]: LanguageKey.Notify_SuggestedPostAutoReplyKeyNotExist,
    [ResponseType.UploadingTimeIsSoSoon]: LanguageKey.Notify_UploadingTimeIsSoSoon,
    [ResponseType.InvalidPreStoryId]: LanguageKey.Notify_InvalidPreStoryId,
    [ResponseType.NotProvidedInstagramerId]: LanguageKey.Notify_NotProvidedInstagramerId,
    [ResponseType.InvalidInstagramerId]: LanguageKey.Notify_InvalidInstagramerId,
    [ResponseType.InvalidThreadId]: LanguageKey.Notify_InvalidThreadId,
    [ResponseType.InvalidLiveMediaId]: LanguageKey.Notify_InvalidLiveMediaId,
    [ResponseType.NotCreatedExportComment]: LanguageKey.Notify_NotCreatedExportComment,
    [ResponseType.CreateExportAvailableWith24HourPeriod]: LanguageKey.Notify_CreateExportAvailableWith24HourPeriod,
    [ResponseType.NotSetted]: LanguageKey.Notify_NotSetted,
    [ResponseType.ExceedGeneralAutoReplyCount]: LanguageKey.Notify_ExceedGeneralAutoReplyCount,
    [ResponseType.InvalidTransactionId]: LanguageKey.Notify_InvalidTransactionId,
    [ResponseType.CannotRenewalPackageWith1MonthTimeExist]: LanguageKey.Notify_CannotRenewalPackageWith1MonthTimeExist,
    [ResponseType.CannotDeleteCurrentSession]: LanguageKey.Notify_CannotDeleteCurrentSession,
    [ResponseType.InvalidSessionId]: LanguageKey.Notify_InvalidSessionId,
    [ResponseType.CannotDeleteCurrentSessionForNewSessionFor1Day]:
      LanguageKey.Notify_CannotDeleteCurrentSessionForNewSessionFor1Day,
    [ResponseType.UpgradedBefore]: LanguageKey.Notify_UpgradedBefore,
    [ResponseType.PermissionNotExist]: LanguageKey.Notify_PermissionNotExist,
    [ResponseType.NotExistUser]: LanguageKey.Notify_NotExistUser,
    [ResponseType.UserAlreadyAsPartner]: LanguageKey.Notify_UserAlreadyAsPartner,
    [ResponseType.ReachMaxPartnerCount]: LanguageKey.Notify_ReachMaxPartnerCount,
    [ResponseType.InvalidPartnerRoleProvided]: LanguageKey.Notify_InvalidPartnerRoleProvided,
    [ResponseType.PartnerRolesLengthIsZero]: LanguageKey.Notify_PartnerRolesLengthIsZero,
    [ResponseType.PartnerNotExist]: LanguageKey.Notify_PartnerNotExist,
    [ResponseType.CannotMakeYourSelfPartnerAsPartnerForYourSelf]:
      LanguageKey.Notify_CannotMakeYourSelfPartnerAsPartnerForYourSelf,
    [ResponseType.PartnerExpireTimeMustBeBiggerThan1HourFromNow]:
      LanguageKey.Notify_PartnerExpireTimeMustBeBiggerThan1HourFromNow,
    [ResponseType.PartnerNameCannotExceed100]: LanguageKey.Notify_PartnerNameCannotExceed100,
    [ResponseType.ProductIsMultiSubproducted]: LanguageKey.Notify_ProductIsMultiSubproducted,
    [ResponseType.InvalidSubProductId]: LanguageKey.Notify_InvalidSubProductId,
    [ResponseType.ProductIdOutOfStock]: LanguageKey.Notify_ProductIdOutOfStock,
    [ResponseType.SubProductIdRequired]: LanguageKey.Notify_SubProductIdRequired,
    [ResponseType.CardIsEmpty]: LanguageKey.Notify_CardIsEmpty,
    [ResponseType.InvalidAddressId]: LanguageKey.Notify_InvalidAddressId,
    [ResponseType.ExceedTotalCreateAddress]: LanguageKey.Notify_ExceedTotalCreateAddress,
    [ResponseType.NotSupportedCountry]: LanguageKey.Notify_NotSupportedCountry,
    [ResponseType.CannotFetchAddressInThisEndpoint]: LanguageKey.Notify_CannotFetchAddressInThisEndpoint,
    [ResponseType.InvalidPostalCode]: LanguageKey.Notify_InvalidPostalCode,
    [ResponseType.NeedCompleteAddress]: LanguageKey.Notify_NeedCompleteAddress,
    [ResponseType.CannotBuyFromYourSelf]: LanguageKey.Notify_CannotBuyFromYourSelf,
    [ResponseType.AllReadyIsBusiness]: LanguageKey.Notify_AllReadyIsBusiness,
    [ResponseType.InvalidBusinessType]: LanguageKey.Notify_InvalidBusinessType,
    [ResponseType.UserAlreadyAuthorized]: LanguageKey.Notify_UserAlreadyAuthorized,
    [ResponseType.InstagramerNotInfluencer]: LanguageKey.Notify_InstagramerNotInfluencer,
    [ResponseType.InstagramerNotShopper]: LanguageKey.Notify_InstagramerNotShopper,
    [ResponseType.AuthorizedInstagramerBefore]: LanguageKey.Notify_AuthorizedInstagramerBefore,
    [ResponseType.UserNotAuthorizedYet]: LanguageKey.Notify_UserNotAuthorizedYet,
    [ResponseType.InstagramerNotAuthorized]: LanguageKey.Notify_InstagramerNotAuthorized,
    [ResponseType.InvalidBankCardNumber]: LanguageKey.Notify_InvalidBankCardNumber,
    [ResponseType.TheOwnerOfPhoneNumberNotBlongsNationalNumber]:
      LanguageKey.Notify_TheOwnerOfPhoneNumberNotBlongsNationalNumber,
    [ResponseType.CouponCodeAlreadyExists]: LanguageKey.Notify_CouponCodeAlreadyExists,
    [ResponseType.InvalidCouponId]: LanguageKey.Notify_InvalidCouponId,
    [ResponseType.CannotChangeShowPrivateCouponInBio]: LanguageKey.Notify_CannotChangeShowPrivateCouponInBio,
    [ResponseType.InvalidCouponCode]: LanguageKey.Notify_InvalidCouponCode,
    [ResponseType.CouponForAnotherPerson]: LanguageKey.Notify_CouponForAnotherPerson,
    [ResponseType.CouponExpired]: LanguageKey.Notify_CouponExpired,
    [ResponseType.CouponDeleted]: LanguageKey.Notify_CouponDeleted,
    [ResponseType.CouponUsedUp]: LanguageKey.Notify_CouponUsedUp,
    [ResponseType.InvalidUsernameSearchQuery]: LanguageKey.Notify_InvalidUsernameSearchQuery,
    [ResponseType.PreviouslyAddedShopAddress]: LanguageKey.Notify_PreviouslyAddedShopAddress,
    [ResponseType.NotSettedShopperAddress]: LanguageKey.Notify_NotSettedShopperAddress,
    [ResponseType.NotExistAnyLogesticInYourCountry]: LanguageKey.Notify_NotExistAnyLogesticInYourCountry,
    [ResponseType.InvalidLogesticIds]: LanguageKey.Notify_InvalidLogesticIds,
    [ResponseType.LogsticsNotSetted]: LanguageKey.Notify_LogsticsNotSetted,
    [ResponseType.NotCommpletedAllBusinessVerification]: LanguageKey.Notify_NotCommpletedAllBusinessVerification,
    [ResponseType.ThisParcelNotSupportedByAnySelectedAvailableLogestic]:
      LanguageKey.Notify_ThisParcelNotSupportedByAnySelectedAvailableLogestic,
    [ResponseType.NotSupportedLogestic]: LanguageKey.Notify_NotSupportedLogestic,
    [ResponseType.ExceedLogesticHeight]: LanguageKey.Notify_ExceedLogesticHeight,
    [ResponseType.ExceedLogesticWidth]: LanguageKey.Notify_ExceedLogesticWidth,
    [ResponseType.ExceedLogesticLength]: LanguageKey.Notify_ExceedLogesticLength,
    [ResponseType.ExceedLogesticTotalLength]: LanguageKey.Notify_ExceedLogesticTotalLength,
    [ResponseType.ExceedLogesticWeight]: LanguageKey.Notify_ExceedLogesticWeight,
    [ResponseType.UserAddressesIsEmptyOrNotSetDefaultAddress]:
      LanguageKey.Notify_UserAddressesIsEmptyOrNotSetDefaultAddress,
    [ResponseType.NotSupportedBoxByThisDimensions]: LanguageKey.Notify_NotSupportedBoxByThisDimensions,
    [ResponseType.CannotAvailableOutOfStackProduct]: LanguageKey.Notify_CannotAvailableOutOfStackProduct,
    [ResponseType.YouAreDeadInCivilRegistration]: LanguageKey.Notify_YouAreDeadInCivilRegistration,
    [ResponseType.InstagramerAlreadyAuthorized]: LanguageKey.Notify_InstagramerAlreadyAuthorized,
    [ResponseType.ThreadShouldBeActiveForSendMessage]: LanguageKey.Notify_ThreadShouldBeActiveForSendMessage,
    [ResponseType.PreviouslyClosedTicket]: LanguageKey.Notify_PreviouslyClosedTicket,
    [ResponseType.NotMatchedCart]: LanguageKey.Notify_NotMatchedCart,
    [ResponseType.PhoneNumberNotBlongsNationalNumber]: LanguageKey.Notify_PhoneNumberNotBlongsNationalNumber,
    [ResponseType.NotMatchedCardNumberAndIdentity]: LanguageKey.Notify_NotMatchedCardNumberAndIdentity,
    [ResponseType.SuspendedShop]: LanguageKey.Notify_SuspendedShop,
    [ResponseType.LogesticIdNotSpecifiedForaPostParcel]: LanguageKey.Notify_LogesticIdNotSpecifiedForaPostParcel,
    [ResponseType.LogesticNotInAvailableLogestics]: LanguageKey.Notify_LogesticNotInAvailableLogestics,
    [ResponseType.ExceedProductReportForLast24Hour]: LanguageKey.Notify_ExceedProductReportForLast24Hour,
    [ResponseType.PreviouslyReportedThisProduct]: LanguageKey.Notify_PreviouslyReportedThisProduct,
    [ResponseType.InvalidOrderId]: LanguageKey.Notify_InvalidOrderId,
    [ResponseType.NotPendingPayRequest]: LanguageKey.Notify_NotPendingPayRequest,
    [ResponseType.NotExistShopAddress]: LanguageKey.Notify_NotExistShopAddress,
    [ResponseType.InvalidOrderStatus]: LanguageKey.Notify_InvalidOrderStatus,
    [ResponseType.CancelInvoiceFailed]: LanguageKey.Notify_CancelInvoiceFailed,
    [ResponseType.PaymentSystemNotSupportedThisPriceType]: LanguageKey.Notify_PaymentSystemNotSupportedThisPriceType,
    [ResponseType.InvalidSentOrderType]: LanguageKey.Notify_InvalidSentOrderType,
    [ResponseType.InvalidParcelId]: LanguageKey.Notify_InvalidParcelId,
    [ResponseType.AddedParcelIdBefore]: LanguageKey.Notify_AddedParcelIdBefore,
    [ResponseType.InvoiceNotOnPaid]: LanguageKey.Notify_InvoiceNotOnPaid,
    [ResponseType.CreatedSystemTicketOnOrderBefore]: LanguageKey.Notify_CreatedSystemTicketOnOrderBefore,
    [ResponseType.PaymentServiceNotResponding]: LanguageKey.Notify_PaymentServiceNotResponding,
    [ResponseType.YouAreNotAdmin]: LanguageKey.Notify_YouAreNotAdmin,
    [ResponseType.YouAreNotASubAdmin]: LanguageKey.Notify_YouAreNotASubAdmin,
    [ResponseType.InvalidFbId]: LanguageKey.Notify_InvalidFbId,
    [ResponseType.InvalidFeatureId]: LanguageKey.Notify_InvalidFeatureId,
    [ResponseType.InActiveFeature]: LanguageKey.Notify_InActiveFeature,
    [ResponseType.FeaturePaused]: LanguageKey.Notify_FeaturePaused,
    [ResponseType.InvalidPromptInput]: LanguageKey.Notify_InvalidPromptInput,
    [ResponseType.PromptNotGenerated]: LanguageKey.Notify_PromptNotGenerated,
    [ResponseType.AIGeneratorFailed]: LanguageKey.Notify_AIGeneratorFailed,
    [ResponseType.NotExecutedPromptForCommentYet]: LanguageKey.Notify_NotExecutedPromptForCommentYet,
    [ResponseType.InstagramPermissionNotExist]: LanguageKey.Notify_InstagramPermissionNotExist,
    [ResponseType.InvalidTimeZone]: LanguageKey.Notify_InvalidTimeZone,
    [ResponseType.PromptCaptionExampleNotGenerated]: LanguageKey.Notify_PromptCaptionExampleNotGenerated,
    [ResponseType.InvalidMasterFlowId]: LanguageKey.Notify_InvalidMasterFlowId,
    [ResponseType.InvalidFlowId]: LanguageKey.Notify_InvalidFlowId,
    [ResponseType.EmptySubFlows]: LanguageKey.Notify_EmptySubFlows,
    [ResponseType.InvalidFlowObject]: LanguageKey.Notify_InvalidFlowObject,
    [ResponseType.InvalidMasterFlowTitle]: LanguageKey.Notify_InvalidMasterFlowTitle,
    [ResponseType.InvalidPromptId]: LanguageKey.Notify_InvalidPromptId,
    [ResponseType.ExceedThreadTokenLimit]: LanguageKey.Notify_ExceedThreadTokenLimit,
    [ResponseType.InvalidMediaId]: LanguageKey.Notify_InvalidMediaId,
    [ResponseType.InvalidLotteryId]: LanguageKey.Notify_InvalidLotteryId,
    [ResponseType.CannotAbortNonUpcomingLottery]: LanguageKey.Notify_CannotAbortNonUpcomingLottery,
    [ResponseType.CommentCountExceedFreeExport]: LanguageKey.Notify_CommentCountExceedFreeExport,
    [ResponseType.InvalidReserveFeatureId]: LanguageKey.Notify_InvalidReserveFeatureId,
    [ResponseType.CannotRenewalThisFeatureNow]: LanguageKey.Notify_CannotRenewalThisFeatureNow,
    [ResponseType.InvalidLotteryStatus]: LanguageKey.Notify_InvalidLotteryStatus,
    [ResponseType.PublishedLotteryBannerBefore]: LanguageKey.Notify_PublishedLotteryBannerBefore,
    [ResponseType.LotteryWinnerBannerIsNull]: LanguageKey.Notify_LotteryWinnerBannerIsNull,
    [ResponseType.InvalidCustomPromptSigniture]: LanguageKey.Notify_InvalidCustomPromptSigniture,
    [ResponseType.ServiceTemporarilyUnavailable]: LanguageKey.Notify_ServiceTemporarilyUnavailable,
    [ResponseType.PageSummaryNotGenerated]: LanguageKey.Notify_PageSummaryNotGenerated,
    [ResponseType.GenerateAIFail]: LanguageKey.Notify_GenerateAIFail,
    [ResponseType.InvalidPageAnalysis]: LanguageKey.Notify_InvalidPageAnalysis,
    [ResponseType.InvalidCustomPrompt]: LanguageKey.Notify_InvalidCustomPrompt,
    [ResponseType.AIModelNotSupportImage]: LanguageKey.Notify_AIModelNotSupportImage,
    [ResponseType.PromptNotSupportImage]: LanguageKey.Notify_PromptNotSupportImage,
    [ResponseType.AIModelNotSupportAudio]: LanguageKey.Notify_AIModelNotSupportAudio,
    [ResponseType.PromptNotSupportVoice]: LanguageKey.Notify_PromptNotSupportVoice,
    [ResponseType.AIModelNotSupportVideo]: LanguageKey.Notify_AIModelNotSupportVideo,
    [ResponseType.InvalidPrompt]: LanguageKey.Notify_InvalidPrompt,
    [ResponseType.InvalidImageGeneratorInput]: LanguageKey.Notify_InvalidImageGeneratorInput,
    [ResponseType.InSuffcientNumberOfImage]: LanguageKey.Notify_InSuffcientNumberOfImage,
    [ResponseType.CreateImageExceedLimit]: LanguageKey.Notify_CreateImageExceedLimit,
    [ResponseType.InvalidPromptType]: LanguageKey.Notify_InvalidPromptType,
    [ResponseType.UnSupportedAIInputType]: LanguageKey.Notify_UnSupportedAIInputType,
    [ResponseType.UnSupportedOrientationType]: LanguageKey.Notify_UnSupportedOrientationType,
    [ResponseType.SoraFailedAiCall]: LanguageKey.Notify_SoraFailedAiCall,
    [ResponseType.AIVideoSecondNotSupported]: LanguageKey.Notify_AIVideoSecondNotSupported,
    [ResponseType.FailedToTraslateDescription]: LanguageKey.Notify_FailedToTraslateDescription,
    [ResponseType.FailedToGenerateEmbedVector]: LanguageKey.Notify_FailedToGenerateEmbedVector,
    [ResponseType.NotGeneratedSummaryYet]: LanguageKey.Notify_NotGeneratedSummaryYet,
    [ResponseType.NoEventsFoundForTheGivenTimeRange]: LanguageKey.Notify_NoEventsFoundForTheGivenTimeRange,
    [ResponseType.NoEventsFoundForThisPrompt]: LanguageKey.Notify_NoEventsFoundForThisPrompt,
    [ResponseType.PageAnalysisNotExist]: LanguageKey.Notify_PageAnalysisNotExist,
    [ResponseType.NoEventIdeaGenerated]: LanguageKey.Notify_NoEventIdeaGenerated,
    [ResponseType.ThisCustomDomainCreatedBefore]: LanguageKey.Notify_ThisCustomDomainCreatedBefore,
    [ResponseType.ThisCustomDomainBelongsToAnother]: LanguageKey.Notify_ThisCustomDomainBelongsToAnother,
    [ResponseType.YouCustomDomainRequestedBeforeWaitATimeToRequestAgain]:
      LanguageKey.Notify_YouCustomDomainRequestedBeforeWaitATimeToRequestAgain,
    [ResponseType.LetsEncryptError]: LanguageKey.Notify_LetsEncryptError,
    [ResponseType.NoPendingCustomDomain]: LanguageKey.Notify_NoPendingCustomDomain,
    [ResponseType.YouCustomDomainCheckedBeforeWaitATimeToCheckAgain]:
      LanguageKey.Notify_YouCustomDomainCheckedBeforeWaitATimeToCheckAgain,
    [ResponseType.CustomDomainVerificationNotPassed]: LanguageKey.Notify_CustomDomainVerificationNotPassed,
    [ResponseType.InvalidProductTempId]: LanguageKey.Notify_InvalidProductTempId,
    [ResponseType.InvalidPriceType]: LanguageKey.Notify_InvalidPriceType,
    [ResponseType.AuthorizeCountryRequired]: LanguageKey.Notify_AuthorizeCountryRequired,
    [ResponseType.ProperyMustBeNumeric]: LanguageKey.Notify_ProperyMustBeNumeric,
    [ResponseType.PhoneNumberAddedBefore]: LanguageKey.Notify_PhoneNumberAddedBefore,
    [ResponseType.WhatsAppCodeSendedBeforeAndWait1Day]: LanguageKey.Notify_WhatsAppCodeSendedBeforeAndWait1Day,
    [ResponseType.WhatsAppCodeNotRequested]: LanguageKey.Notify_WhatsAppCodeNotRequested,
    [ResponseType.WhatsAppCodeMaxInvalidCountReach]: LanguageKey.Notify_WhatsAppCodeMaxInvalidCountReach,
    [ResponseType.UserWithThisPhoneNumberAlreadyExist]: LanguageKey.Notify_UserWithThisPhoneNumberAlreadyExist,
    [ResponseType.InvalidAIToolId]: LanguageKey.Notify_InvalidAIToolId,
    [ResponseType.AIToolParameterRequired]: LanguageKey.Notify_AIToolParameterRequired,
    [ResponseType.AIToolParameterNotRequired]: LanguageKey.Notify_AIToolParameterNotRequired,
    [ResponseType.ExceedDailyLimit]: LanguageKey.Notify_ExceedDailyLimit,
    [ResponseType.CannotGetTwitchRightNow]: LanguageKey.Notify_CannotGetTwitchRightNow,
    [ResponseType.InvalidTwitchChannelId]: LanguageKey.Notify_InvalidTwitchChannelId,
    [ResponseType.PhoneNumberRequired]: LanguageKey.Notify_PhoneNumberRequired,
    [ResponseType.NotVerifiedHost]: LanguageKey.Notify_NotVerifiedHost,
    [ResponseType.NotBusinesser]: LanguageKey.Notify_NotBusinesser,
    [ResponseType.NotFoundAnySuggestedCategory]: LanguageKey.Notify_NotFoundAnySuggestedCategory,
    [ResponseType.NoInvoiceExist]: LanguageKey.Notify_NoInvoiceExist,
    [ResponseType.InvalidMediaAiCreatorKey]: LanguageKey.Notify_InvalidMediaAiCreatorKey,
    [ResponseType.InvalidMediaAiVersionKey]: LanguageKey.Notify_InvalidMediaAiVersionKey,
    [ResponseType.InvalidMediaAiRequestModel]: LanguageKey.Notify_InvalidMediaAiRequestModel,
    [ResponseType.MediaAIError]: LanguageKey.Notify_MediaAIError,
    [ResponseType.TwitchChannelDoestHaveAnyVideo]: LanguageKey.Notify_TwitchChannelDoestHaveAnyVideo,
    [ResponseType.CouponAlreadyDeleted]: LanguageKey.Notify_CouponAlreadyDeleted,
    [ResponseType.CouponNotDeleted]: LanguageKey.Notify_CouponNotDeleted,
    [ResponseType.ExceedSubFlowCount]: LanguageKey.Notify_ExceedSubFlowCount,
    [ResponseType.ExceedFlowDepth]: LanguageKey.Notify_ExceedFlowDepth,
    [ResponseType.ExceedFlowItemCount]: LanguageKey.Notify_ExceedFlowItemCount,
    [ResponseType.ExceedFlowMediaAudioCount]: LanguageKey.Notify_ExceedFlowMediaAudioCount,
    [ResponseType.OneFlowButtonHasEmptyItem]: LanguageKey.Notify_OneFlowButtonHasEmptyItem,
  };

  const languageKey = responseTextMap[responseType];
  if (languageKey) {
    return `${i18next.t(languageKey)} - (#${1000 + responseType})`;
  }
  return `${i18next.t(LanguageKey.Notify_Unexpected)} - (#${1000 + responseType})`;
};

// Legacy function for internal responses (with translation)
const getInternalResponseTextLegacy = (responseType: InternalResponseType): string => {
  const internalResponseTextMap: Record<InternalResponseType, LanguageKey> = {
    [InternalResponseType.Ok]: LanguageKey.InternalNotify_Ok,
    [InternalResponseType.RepetitiveHashtagInput]: LanguageKey.InternalNotify_RepetitiveHashtagInput,
    [InternalResponseType.NotFoundDevice]: LanguageKey.InternalNotify_NotFoundDevice,
    [InternalResponseType.EmptyHashtagList]: LanguageKey.InternalNotify_EmptyHashtagList,
    [InternalResponseType.CannotCreatePrePostNow]: LanguageKey.InternalNotify_CannotCreatePrePostNow,
    [InternalResponseType.PrivateAccountSelectedForCheckHashtag]:
      LanguageKey.InternalNotify_PrivateAccountSelectedForCheckHashtag,
    [InternalResponseType.InstagramLoginRequired]: LanguageKey.InternalNotify_InstagramLoginRequired,
    [InternalResponseType.InstagramLoginRequiredForVerifiedAccount]:
      LanguageKey.InternalNotify_InstagramLoginRequiredForVerifiedAccount,
    [InternalResponseType.PrivateOrVerifiedSponsor]: LanguageKey.InternalNotify_PrivateOrVerifiedSponsor,
    [InternalResponseType.InstagramLoginRequiredForPrivateAccount]:
      LanguageKey.InternalNotify_InstagramLoginRequiredForPrivateAccount,
    [InternalResponseType.StartUploadingPost]: LanguageKey.InternalNotify_StartUploadingPost,
    [InternalResponseType.UploadingPostError]: LanguageKey.InternalNotify_UploadingPostError,
    [InternalResponseType.PostUploaded]: LanguageKey.InternalNotify_PostUploaded,
    [InternalResponseType.ExceededMedia]: LanguageKey.InternalNotify_ExceededMedia,
    [InternalResponseType.More4IceBreaker]: LanguageKey.InternalNotify_More4IceBreaker,
    [InternalResponseType.CopyLink]: LanguageKey.InternalNotify_CopyLink,
    [InternalResponseType.copy]: LanguageKey.InternalNotify_copy,
    [InternalResponseType.CopyTrackingpost]: LanguageKey.InternalNotify_CopyTrackingpost,
    [InternalResponseType.Network]: LanguageKey.InternalNotify_Network,
    [InternalResponseType.TimeExpire]: LanguageKey.InternalNotify_TimeExpire,
    [InternalResponseType.ExceedPermittedHashtagNumber]: LanguageKey.InternalNotify_ExceedPermittedHashtagNumber,
    [InternalResponseType.ExceedPermittedUploadMedia]: LanguageKey.InternalNotify_ExceedPermittedUploadMedia,
    [InternalResponseType.UnexpectedError]: LanguageKey.InternalNotify_UnexpectedError,
    [InternalResponseType.CopyToClipboard]: LanguageKey.InternalNotify_CopyToClipboard,
    [InternalResponseType.FillRedBorderFields]: LanguageKey.InternalNotify_FillRedBorderFields,
    [InternalResponseType.RepeatedVariation]: LanguageKey.InternalNotify_RepeatedVariation,
    [InternalResponseType.NeedOneProduct]: LanguageKey.InternalNotify_NeedOneProduct,
    [InternalResponseType.UploadMedia]: LanguageKey.InternalNotify_UploadMedia,
    [InternalResponseType.TurnOnProxy]: LanguageKey.InternalNotify_TurnOnProxy,
    [InternalResponseType.ExceedPermittedLiveTime]: LanguageKey.InternalNotify_ExceedPermittedLiveTime,
    [InternalResponseType.CommentDisabled]: LanguageKey.InternalNotify_CommentDisabled,
    [InternalResponseType.ExceedSelectedCollaboratorPage]: LanguageKey.InternalNotify_ExceedSelectedCollaboratorPage,
    [InternalResponseType.RepetitiveCollaboratorPage]: LanguageKey.InternalNotify_RepetitiveCollaboratorPage,
    [InternalResponseType.ExceedPermittedSizeOfImage]: LanguageKey.InternalNotify_ExceedPermittedSizeOfImage,
    [InternalResponseType.ExceedPermittedAspectRatioAlbum]: LanguageKey.InternalNotify_ExceedPermittedAspectRatioAlbum,
    [InternalResponseType.ExceedPermittedSizeOfVideoAlbum]: LanguageKey.InternalNotify_ExceedPermittedSizeOfVideoAlbum,
    [InternalResponseType.ExceedPermittedDurationOfVideoAlbum]:
      LanguageKey.InternalNotify_ExceedPermittedDurationOfVideoAlbum,
    [InternalResponseType.ExceedPermittedAspectRatioReels]: LanguageKey.InternalNotify_ExceedPermittedAspectRatioReels,
    [InternalResponseType.ExceedPermittedSizeOfVideoReels]: LanguageKey.InternalNotify_ExceedPermittedSizeOfVideoReels,
    [InternalResponseType.ExceedPermittedDurationOfVideoReels]:
      LanguageKey.InternalNotify_ExceedPermittedDurationOfVideoReels,
    [InternalResponseType.NotPermittedMediaType]: LanguageKey.InternalNotify_NotPermittedMediaType,
    [InternalResponseType.InvalidMetaData]: LanguageKey.InternalNotify_InvalidMetaData,
    [InternalResponseType.ExceedSelectedMaxTaggedPeople]: LanguageKey.InternalNotify_ExceedSelectedMaxTaggedPeople,
    [InternalResponseType.ExceedSelectedMaxHashtags]: LanguageKey.InternalNotify_ExceedSelectedMaxHashtags,
    [InternalResponseType.ExistedInCollaborate]: LanguageKey.InternalNotify_ExistedInCollaborate,
    [InternalResponseType.ExceedPermittedAspectRatioStory]: LanguageKey.InternalNotify_ExceedPermittedAspectRatioStory,
    [InternalResponseType.ExceedPermittedSizeOfVideoStory]: LanguageKey.InternalNotify_ExceedPermittedSizeOfVideoStory,
    [InternalResponseType.ExceedPermittedWidthOfVideo]: LanguageKey.InternalNotify_ExceedPermittedWidthOfVideo,
    [InternalResponseType.ExceedPermittedDurationOfVideoStory]:
      LanguageKey.InternalNotify_ExceedPermittedDurationOfVideoStory,
    [InternalResponseType.BelowMinimumDurationOfVideoStory]:
      LanguageKey.InternalNotify_BelowMinimumDurationOfVideoStory,
    [InternalResponseType.ExceedPermittedSpecificWordForAutoreply]:
      LanguageKey.InternalNotify_ExceedPermittedSpecificWordForAutoreply,
    [InternalResponseType.ExceedPermittedAspectRatioImage]: LanguageKey.InternalNotify_ExceedPermittedAspectRatioImage,
    [InternalResponseType.Success]: LanguageKey.InternalNotify_Success,
    [InternalResponseType.CreateExportAvailableWith24HourPeriod]:
      LanguageKey.InternalNotify_CreateExportAvailableWith24HourPeriod,
    [InternalResponseType.SaveIceBreaker]: LanguageKey.InternalNotify_SaveIceBreaker,
    [InternalResponseType.deleteIceBreaker]: LanguageKey.InternalNotify_deleteIceBreaker,
    [InternalResponseType.SavePersistenceMenu]: LanguageKey.InternalNotify_SavePersistenceMenu,
    [InternalResponseType.SelectLanguage]: LanguageKey.InternalNotify_SelectLanguage,
    [InternalResponseType.SaveFollowTemplate]: LanguageKey.InternalNotify_SaveFollowTemplate,
    [InternalResponseType.AutoReplyOn]: LanguageKey.InternalNotify_AutoReplyOn,
    [InternalResponseType.AutoReplyOff]: LanguageKey.InternalNotify_AutoReplyOff,
    [InternalResponseType.AutoGeneralOn]: LanguageKey.InternalNotify_AutoGeneralOn,
    [InternalResponseType.AutoGeneralOff]: LanguageKey.InternalNotify_AutoGeneralOff,
    [InternalResponseType.MaxInEachCard]: LanguageKey.InternalNotify_MaxInEachCard,
    [InternalResponseType.ExceedStockCard]: LanguageKey.InternalNotify_ExceedStockCard,
    [InternalResponseType.DefaultAddress]: LanguageKey.InternalNotify_DefaultAddress,
    [InternalResponseType.FetchingYourData]: LanguageKey.InternalNotify_FetchingYourData,
    [InternalResponseType.EmptyTitleInQuickReply]: LanguageKey.InternalNotify_EmptyTitleInQuickReply,
    [InternalResponseType.EmptyTitleForOutputsInQuickReply]:
      LanguageKey.InternalNotify_EmptyTitleForOutputsInQuickReply,
    [InternalResponseType.EmptyTitleForFlow]: LanguageKey.InternalNotify_EmptyTitleForFlow,
    [InternalResponseType.MultipleFlowForPrivateReply]: LanguageKey.InternalNotify_MultipleFlowForPrivateReply,
    [InternalResponseType.NotPermittedForDownload]: LanguageKey.InternalNotify_NotPermittedForDownload,
    [InternalResponseType.NotFeature]: LanguageKey.InternalNotify_NotFeature,
    [InternalResponseType.ExceedBasefeatureTime]: LanguageKey.InternalNotify_ExceedBasefeatureTime,
    [InternalResponseType.ChannelIdNotStartedWithUC]: LanguageKey.InternalNotify_ChannelIdNotStartedWithUC,
    [InternalResponseType.PageAnalysisNotCompleted]: LanguageKey.InternalNotify_PageAnalysisNotCompleted,
  };

  const languageKey = internalResponseTextMap[responseType];
  if (languageKey) {
    return `${i18next.t(languageKey)} - (#${1000 + responseType})`;
  }
  return `${i18next.t(LanguageKey.Notify_Unexpected)} - (#${1000 + responseType})`;
};

// Helper function to get translated response text
const getResponseText = (responseType: ResponseType, t: (key: LanguageKey) => string): string => {
  const responseTextMap: Record<ResponseType, LanguageKey> = {
    [ResponseType.Ok]: LanguageKey.Notify_Ok,
    [ResponseType.InternalException]: LanguageKey.Notify_InternalException,
    [ResponseType.CannotSendSmsNow]: LanguageKey.Notify_CannotSendSmsNow,
    [ResponseType.InvalidPhoneNumber]: LanguageKey.Notify_InvalidPhoneNumber,
    [ResponseType.InvalidCountryCode]: LanguageKey.Notify_InvalidCountryCode,
    [ResponseType.PhoneNumberNotAvailableInThisCountry]: LanguageKey.Notify_PhoneNumberNotAvailableInThisCountry,
    [ResponseType.InstagramerIdNotExist]: LanguageKey.Notify_InstagramerIdNotExist,
    [ResponseType.EmptyProductList]: LanguageKey.Notify_EmptyProductList,
    [ResponseType.InvalidVerificationCode]: LanguageKey.Notify_InvalidVerificationCode,
    [ResponseType.LowQuality]: LanguageKey.Notify_LowQuality,
    [ResponseType.CannotEmptyChildren]: LanguageKey.Notify_CannotEmptyChildren,
    [ResponseType.InvalidAspectRatio]: LanguageKey.Notify_InvalidAspectRatio,
    [ResponseType.InvalidMediaCodec]: LanguageKey.Notify_InvalidMediaCodec,
    [ResponseType.InvalidMediaType]: LanguageKey.Notify_InvalidMediaType,
    [ResponseType.MediaUrlNotAccessible]: LanguageKey.Notify_MediaUrlNotAccessible,
    [ResponseType.CannotCreatePrePostNow]: LanguageKey.Notify_CannotCreatePrePostNow,
    [ResponseType.InvalidMediaContent]: LanguageKey.Notify_InvalidMediaContent,
    [ResponseType.Unexpected]: LanguageKey.Notify_Unexpected,
    [ResponseType.TooManyRequestForImageHashtagGenerator]: LanguageKey.Notify_TooManyRequestForImageHashtagGenerator,
    [ResponseType.LoginFailed]: LanguageKey.Notify_LoginFailed,
    [ResponseType.NullUserId]: LanguageKey.Notify_NullUserId,
    [ResponseType.RealtimeSocketNotExist]: LanguageKey.Notify_RealtimeSocketNotExist,
    [ResponseType.PushSocketNotExist]: LanguageKey.Notify_PushSocketNotExist,
    [ResponseType.InstaApiNotFoundForConnect]: LanguageKey.Notify_InstaApiNotFoundForConnect,
    [ResponseType.EmptyHashtagList]: LanguageKey.Notify_EmptyHashtagList,
    [ResponseType.InvalidHashtagListId]: LanguageKey.Notify_InvalidHashtagListId,
    [ResponseType.DeleteHashtagFail]: LanguageKey.Notify_DeleteHashtagFail,
    [ResponseType.InvalidBase64Content]: LanguageKey.Notify_InvalidBase64Content,
    [ResponseType.InvalidTermsAndConditionSvgType]: LanguageKey.Notify_InvalidTermsAndConditionSvgType,
    [ResponseType.InvalidLotteryAnnouncementBannerId]: LanguageKey.Notify_InvalidLotteryAnnouncementBannerId,
    [ResponseType.InvalidLotteryAnnouncementBannerStr]: LanguageKey.Notify_InvalidLotteryAnnouncementBannerStr,
    [ResponseType.InvalidPostId]: LanguageKey.Notify_InvalidPostId,
    [ResponseType.TooSoonLotteryInfo]: LanguageKey.Notify_TooSoonLotteryInfo,
    [ResponseType.InvalidDirectParams]: LanguageKey.Notify_InvalidDirectParams,
    [ResponseType.NoInstagramerExists]: LanguageKey.Notify_NoInstagramerExists,
    [ResponseType.PropertyNotFoundOrNull]: LanguageKey.Notify_PropertyNotFoundOrNull,
    [ResponseType.ReachNumberOfPinDirect]: LanguageKey.Notify_ReachNumberOfPinDirect,
    [ResponseType.InvalidStoryId]: LanguageKey.Notify_InvalidStoryId,
    [ResponseType.MaxPrePostReach]: LanguageKey.Notify_MaxPrePostReach,
    [ResponseType.InvalidDraftId]: LanguageKey.Notify_InvalidDraftId,
    [ResponseType.InvalidPrePostId]: LanguageKey.Notify_InvalidPrePostId,
    [ResponseType.ReachHashtagListLimit]: LanguageKey.Notify_ReachHashtagListLimit,
    [ResponseType.EmptyUsername]: LanguageKey.Notify_EmptyUsername,
    [ResponseType.TooManyRequestForPageHashtagAnalysis]: LanguageKey.Notify_TooManyRequestForPageHashtagAnalysis,
    [ResponseType.PasswordRequired]: LanguageKey.Notify_PasswordRequired,
    [ResponseType.PackageRequiredInThisTime]: LanguageKey.Notify_PackageRequiredInThisTime,
    [ResponseType.FeatureRequiredInThisTime]: LanguageKey.Notify_FeatureRequiredInThisTime,
    [ResponseType.NoShopperExist]: LanguageKey.Notify_NoShopperExist,
    [ResponseType.FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount]:
      LanguageKey.Notify_FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount,
    [ResponseType.FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount]:
      LanguageKey.Notify_FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount,
    [ResponseType.InvalidLinkId]: LanguageKey.Notify_InvalidLinkId,
    [ResponseType.ReachMaxBioLink]: LanguageKey.Notify_ReachMaxBioLink,
    [ResponseType.OnlyBusinessAccountHasThisAccess]: LanguageKey.Notify_OnlyBusinessAccountHasThisAccess,
    [ResponseType.NoYoutubeChannelFound]: LanguageKey.Notify_NoYoutubeChannelFound,
    [ResponseType.CannotGetYoutubeRightNow]: LanguageKey.Notify_CannotGetYoutubeRightNow,
    [ResponseType.AparatUsernameNotFound]: LanguageKey.Notify_AparatUsernameNotFound,
    [ResponseType.AparatChannelHasNotAnyVideo]: LanguageKey.Notify_AparatChannelHasNotAnyVideo,
    [ResponseType.InvalidYoutubeChannelId]: LanguageKey.Notify_InvalidYoutubeChannelId,
    [ResponseType.NoAparatChannelFound]: LanguageKey.Notify_NoAparatChannelFound,
    [ResponseType.CannotGetAparatRightNow]: LanguageKey.Notify_CannotGetAparatRightNow,
    [ResponseType.NotSettedCustomDomain]: LanguageKey.Notify_NotSettedCustomDomain,
    [ResponseType.CannotStoryWithoutWinnerBanner]: LanguageKey.Notify_CannotStoryWithoutWinnerBanner,
    [ResponseType.ExceedMaxStoryWinnerLotteryBanner]: LanguageKey.Notify_ExceedMaxStoryWinnerLotteryBanner,
    [ResponseType.LotteryOnProcessingOrEnded]: LanguageKey.Notify_LotteryOnProcessingOrEnded,
    [ResponseType.CannotAbortLotteryOneHourBefore]: LanguageKey.Notify_CannotAbortLotteryOneHourBefore,
    [ResponseType.CannotAbortFollowerLottery]: LanguageKey.Notify_CannotAbortFollowerLottery,
    [ResponseType.InvalidImageOrExceedMaxSize]: LanguageKey.Notify_InvalidImageOrExceedMaxSize,
    [ResponseType.ExceedLoginAttempt]: LanguageKey.Notify_ExceedLoginAttempt,
    [ResponseType.NotExistComment]: LanguageKey.Notify_NotExistComment,
    [ResponseType.UserNotFound]: LanguageKey.Notify_UserNotFound,
    [ResponseType.ExistInstagramerBefore]: LanguageKey.Notify_ExistInstagramerBefore,
    [ResponseType.CannotChangeBusinessAccountType]: LanguageKey.Notify_CannotChangeBusinessAccountType,
    [ResponseType.InvalidProductId]: LanguageKey.Notify_InvalidProductId,
    [ResponseType.InvalidTrendHashtagPeriod]: LanguageKey.Notify_InvalidTrendHashtagPeriod,
    [ResponseType.InvalidLanguageId]: LanguageKey.Notify_InvalidLanguageId,
    [ResponseType.CannotStoryWithoutTermsBanner]: LanguageKey.Notify_CannotStoryWithoutTermsBanner,
    [ResponseType.ExceedMaxStoryTermsLotteryBanner]: LanguageKey.Notify_ExceedMaxStoryTermsLotteryBanner,
    [ResponseType.LotteryTermsIsNull]: LanguageKey.Notify_LotteryTermsIsNull,
    [ResponseType.CanShareTermsBefore6HoursOfStartLottery]: LanguageKey.Notify_CanShareTermsBefore6HoursOfStartLottery,
    [ResponseType.CanShareTermForOnlyDefinedStatusLotteries]:
      LanguageKey.Notify_CanShareTermForOnlyDefinedStatusLotteries,
    [ResponseType.SharedRemainingTimeBefore]: LanguageKey.Notify_SharedRemainingTimeBefore,
    [ResponseType.ShareRemainingTimeOnlyActiveForScoreLottery]:
      LanguageKey.Notify_ShareRemainingTimeOnlyActiveForScoreLottery,
    [ResponseType.CanShareTermsBefore1HoursOfStartLottery]: LanguageKey.Notify_CanShareTermsBefore1HoursOfStartLottery,
    [ResponseType.InvalidSubProductIds]: LanguageKey.Notify_InvalidSubProductIds,
    [ResponseType.ReachMaxProductMedia]: LanguageKey.Notify_ReachMaxProductMedia,
    [ResponseType.InvalidMediaProductId]: LanguageKey.Notify_InvalidMediaProductId,
    [ResponseType.AccountNotABusiness]: LanguageKey.Notify_AccountNotABusiness,
    [ResponseType.NotFoundProductWithThisTempId]: LanguageKey.Notify_NotFoundProductWithThisTempId,
    [ResponseType.InvalidAvailabilityStatus]: LanguageKey.Notify_InvalidAvailabilityStatus,
    [ResponseType.InvalidIbanNumber]: LanguageKey.Notify_InvalidIbanNumber,
    [ResponseType.ExistedIbanNumber]: LanguageKey.Notify_ExistedIbanNumber,
    [ResponseType.IbanMethodNotAvailableForNotTomanPriceUser]:
      LanguageKey.Notify_IbanMethodNotAvailableForNotTomanPriceUser,
    [ResponseType.SearchQueryIsEmpty]: LanguageKey.Notify_SearchQueryIsEmpty,
    [ResponseType.ExceedMaxInEachCard]: LanguageKey.Notify_ExceedMaxInEachCard,
    [ResponseType.ProductNotAlbumPost]: LanguageKey.Notify_ProductNotAlbumPost,
    [ResponseType.InvalidChildrenId]: LanguageKey.Notify_InvalidChildrenId,
    [ResponseType.NotAvailableProduct]: LanguageKey.Notify_NotAvailableProduct,
    [ResponseType.ExceedStockCount]: LanguageKey.Notify_ExceedStockCount,
    [ResponseType.CannotUnloadAnInstanceProduct]: LanguageKey.Notify_CannotUnloadAnInstanceProduct,
    [ResponseType.InvalidCategoryId]: LanguageKey.Notify_InvalidCategoryId,
    [ResponseType.NotFoundAnyProductOnThisCategory]: LanguageKey.Notify_NotFoundAnyProductOnThisCategory,
    [ResponseType.NotFoundAnyNextProduct]: LanguageKey.Notify_NotFoundAnyNextProduct,
    [ResponseType.NotFoundAnyPreviousProduct]: LanguageKey.Notify_NotFoundAnyPreviousProduct,
    [ResponseType.InvalidItemId]: LanguageKey.Notify_InvalidItemId,
    [ResponseType.IpInvalid]: LanguageKey.Notify_IpInvalid,
    [ResponseType.ThisInstagramAccountAddedBefore]: LanguageKey.Notify_ThisInstagramAccountAddedBefore,
    [ResponseType.InvalidTicketId]: LanguageKey.Notify_InvalidTicketId,
    [ResponseType.ExpiredSignature]: LanguageKey.Notify_ExpiredSignature,
    [ResponseType.Forbidden]: LanguageKey.Notify_Forbidden,
    [ResponseType.ConnectedInstagramPageNotFound]: LanguageKey.Notify_ConnectedInstagramPageNotFound,
    [ResponseType.AllInstagramAccountConnectedAddedBefore]: LanguageKey.Notify_AllInstagramAccountConnectedAddedBefore,
    [ResponseType.SelectInstagramPageToConnect]: LanguageKey.Notify_SelectInstagramPageToConnect,
    [ResponseType.InstagramRedirectRoleNotFound]: LanguageKey.Notify_InstagramRedirectRoleNotFound,
    [ResponseType.FacebookLoginNotFound]: LanguageKey.Notify_FacebookLoginNotFound,
    [ResponseType.SelectedPageNotFound]: LanguageKey.Notify_SelectedPageNotFound,
    [ResponseType.ShouldConnectInstaPageAgain]: LanguageKey.Notify_ShouldConnectInstaPageAgain,
    [ResponseType.InvalidProductSuggestionId]: LanguageKey.Notify_InvalidProductSuggestionId,
    [ResponseType.NotSavedSuggestions]: LanguageKey.Notify_NotSavedSuggestions,
    [ResponseType.ExistedSuggestedMedia]: LanguageKey.Notify_ExistedSuggestedMedia,
    [ResponseType.InvalidUploadMediaUrl]: LanguageKey.Notify_InvalidUploadMediaUrl,
    [ResponseType.SuggestedPostAutoReplyKeyNotExist]: LanguageKey.Notify_SuggestedPostAutoReplyKeyNotExist,
    [ResponseType.UploadingTimeIsSoSoon]: LanguageKey.Notify_UploadingTimeIsSoSoon,
    [ResponseType.InvalidPreStoryId]: LanguageKey.Notify_InvalidPreStoryId,
    [ResponseType.NotProvidedInstagramerId]: LanguageKey.Notify_NotProvidedInstagramerId,
    [ResponseType.InvalidInstagramerId]: LanguageKey.Notify_InvalidInstagramerId,
    [ResponseType.InvalidThreadId]: LanguageKey.Notify_InvalidThreadId,
    [ResponseType.InvalidLiveMediaId]: LanguageKey.Notify_InvalidLiveMediaId,
    [ResponseType.NotCreatedExportComment]: LanguageKey.Notify_NotCreatedExportComment,
    [ResponseType.CreateExportAvailableWith24HourPeriod]: LanguageKey.Notify_CreateExportAvailableWith24HourPeriod,
    [ResponseType.NotSetted]: LanguageKey.Notify_NotSetted,
    [ResponseType.ExceedGeneralAutoReplyCount]: LanguageKey.Notify_ExceedGeneralAutoReplyCount,
    [ResponseType.InvalidTransactionId]: LanguageKey.Notify_InvalidTransactionId,
    [ResponseType.CannotRenewalPackageWith1MonthTimeExist]: LanguageKey.Notify_CannotRenewalPackageWith1MonthTimeExist,
    [ResponseType.CannotDeleteCurrentSession]: LanguageKey.Notify_CannotDeleteCurrentSession,
    [ResponseType.InvalidSessionId]: LanguageKey.Notify_InvalidSessionId,
    [ResponseType.CannotDeleteCurrentSessionForNewSessionFor1Day]:
      LanguageKey.Notify_CannotDeleteCurrentSessionForNewSessionFor1Day,
    [ResponseType.UpgradedBefore]: LanguageKey.Notify_UpgradedBefore,
    [ResponseType.PermissionNotExist]: LanguageKey.Notify_PermissionNotExist,
    [ResponseType.NotExistUser]: LanguageKey.Notify_NotExistUser,
    [ResponseType.UserAlreadyAsPartner]: LanguageKey.Notify_UserAlreadyAsPartner,
    [ResponseType.ReachMaxPartnerCount]: LanguageKey.Notify_ReachMaxPartnerCount,
    [ResponseType.InvalidPartnerRoleProvided]: LanguageKey.Notify_InvalidPartnerRoleProvided,
    [ResponseType.PartnerRolesLengthIsZero]: LanguageKey.Notify_PartnerRolesLengthIsZero,
    [ResponseType.PartnerNotExist]: LanguageKey.Notify_PartnerNotExist,
    [ResponseType.CannotMakeYourSelfPartnerAsPartnerForYourSelf]:
      LanguageKey.Notify_CannotMakeYourSelfPartnerAsPartnerForYourSelf,
    [ResponseType.PartnerExpireTimeMustBeBiggerThan1HourFromNow]:
      LanguageKey.Notify_PartnerExpireTimeMustBeBiggerThan1HourFromNow,
    [ResponseType.PartnerNameCannotExceed100]: LanguageKey.Notify_PartnerNameCannotExceed100,
    [ResponseType.ProductIsMultiSubproducted]: LanguageKey.Notify_ProductIsMultiSubproducted,
    [ResponseType.InvalidSubProductId]: LanguageKey.Notify_InvalidSubProductId,
    [ResponseType.ProductIdOutOfStock]: LanguageKey.Notify_ProductIdOutOfStock,
    [ResponseType.SubProductIdRequired]: LanguageKey.Notify_SubProductIdRequired,
    [ResponseType.CardIsEmpty]: LanguageKey.Notify_CardIsEmpty,
    [ResponseType.InvalidAddressId]: LanguageKey.Notify_InvalidAddressId,
    [ResponseType.ExceedTotalCreateAddress]: LanguageKey.Notify_ExceedTotalCreateAddress,
    [ResponseType.NotSupportedCountry]: LanguageKey.Notify_NotSupportedCountry,
    [ResponseType.CannotFetchAddressInThisEndpoint]: LanguageKey.Notify_CannotFetchAddressInThisEndpoint,
    [ResponseType.InvalidPostalCode]: LanguageKey.Notify_InvalidPostalCode,
    [ResponseType.NeedCompleteAddress]: LanguageKey.Notify_NeedCompleteAddress,
    [ResponseType.CannotBuyFromYourSelf]: LanguageKey.Notify_CannotBuyFromYourSelf,
    [ResponseType.AllReadyIsBusiness]: LanguageKey.Notify_AllReadyIsBusiness,
    [ResponseType.InvalidBusinessType]: LanguageKey.Notify_InvalidBusinessType,
    [ResponseType.UserAlreadyAuthorized]: LanguageKey.Notify_UserAlreadyAuthorized,
    [ResponseType.InstagramerNotInfluencer]: LanguageKey.Notify_InstagramerNotInfluencer,
    [ResponseType.InstagramerNotShopper]: LanguageKey.Notify_InstagramerNotShopper,
    [ResponseType.AuthorizedInstagramerBefore]: LanguageKey.Notify_AuthorizedInstagramerBefore,
    [ResponseType.UserNotAuthorizedYet]: LanguageKey.Notify_UserNotAuthorizedYet,
    [ResponseType.InstagramerNotAuthorized]: LanguageKey.Notify_InstagramerNotAuthorized,
    [ResponseType.InvalidBankCardNumber]: LanguageKey.Notify_InvalidBankCardNumber,
    [ResponseType.TheOwnerOfPhoneNumberNotBlongsNationalNumber]:
      LanguageKey.Notify_TheOwnerOfPhoneNumberNotBlongsNationalNumber,
    [ResponseType.CouponCodeAlreadyExists]: LanguageKey.Notify_CouponCodeAlreadyExists,
    [ResponseType.InvalidCouponId]: LanguageKey.Notify_InvalidCouponId,
    [ResponseType.CannotChangeShowPrivateCouponInBio]: LanguageKey.Notify_CannotChangeShowPrivateCouponInBio,
    [ResponseType.InvalidCouponCode]: LanguageKey.Notify_InvalidCouponCode,
    [ResponseType.CouponForAnotherPerson]: LanguageKey.Notify_CouponForAnotherPerson,
    [ResponseType.CouponExpired]: LanguageKey.Notify_CouponExpired,
    [ResponseType.CouponDeleted]: LanguageKey.Notify_CouponDeleted,
    [ResponseType.CouponUsedUp]: LanguageKey.Notify_CouponUsedUp,
    [ResponseType.InvalidUsernameSearchQuery]: LanguageKey.Notify_InvalidUsernameSearchQuery,
    [ResponseType.PreviouslyAddedShopAddress]: LanguageKey.Notify_PreviouslyAddedShopAddress,
    [ResponseType.NotSettedShopperAddress]: LanguageKey.Notify_NotSettedShopperAddress,
    [ResponseType.NotExistAnyLogesticInYourCountry]: LanguageKey.Notify_NotExistAnyLogesticInYourCountry,
    [ResponseType.InvalidLogesticIds]: LanguageKey.Notify_InvalidLogesticIds,
    [ResponseType.LogsticsNotSetted]: LanguageKey.Notify_LogsticsNotSetted,
    [ResponseType.NotCommpletedAllBusinessVerification]: LanguageKey.Notify_NotCommpletedAllBusinessVerification,
    [ResponseType.ThisParcelNotSupportedByAnySelectedAvailableLogestic]:
      LanguageKey.Notify_ThisParcelNotSupportedByAnySelectedAvailableLogestic,
    [ResponseType.NotSupportedLogestic]: LanguageKey.Notify_NotSupportedLogestic,
    [ResponseType.ExceedLogesticHeight]: LanguageKey.Notify_ExceedLogesticHeight,
    [ResponseType.ExceedLogesticWidth]: LanguageKey.Notify_ExceedLogesticWidth,
    [ResponseType.ExceedLogesticLength]: LanguageKey.Notify_ExceedLogesticLength,
    [ResponseType.ExceedLogesticTotalLength]: LanguageKey.Notify_ExceedLogesticTotalLength,
    [ResponseType.ExceedLogesticWeight]: LanguageKey.Notify_ExceedLogesticWeight,
    [ResponseType.UserAddressesIsEmptyOrNotSetDefaultAddress]:
      LanguageKey.Notify_UserAddressesIsEmptyOrNotSetDefaultAddress,
    [ResponseType.NotSupportedBoxByThisDimensions]: LanguageKey.Notify_NotSupportedBoxByThisDimensions,
    [ResponseType.CannotAvailableOutOfStackProduct]: LanguageKey.Notify_CannotAvailableOutOfStackProduct,
    [ResponseType.YouAreDeadInCivilRegistration]: LanguageKey.Notify_YouAreDeadInCivilRegistration,
    [ResponseType.InstagramerAlreadyAuthorized]: LanguageKey.Notify_InstagramerAlreadyAuthorized,
    [ResponseType.ThreadShouldBeActiveForSendMessage]: LanguageKey.Notify_ThreadShouldBeActiveForSendMessage,
    [ResponseType.PreviouslyClosedTicket]: LanguageKey.Notify_PreviouslyClosedTicket,
    [ResponseType.NotMatchedCart]: LanguageKey.Notify_NotMatchedCart,
    [ResponseType.PhoneNumberNotBlongsNationalNumber]: LanguageKey.Notify_PhoneNumberNotBlongsNationalNumber,
    [ResponseType.NotMatchedCardNumberAndIdentity]: LanguageKey.Notify_NotMatchedCardNumberAndIdentity,
    [ResponseType.SuspendedShop]: LanguageKey.Notify_SuspendedShop,
    [ResponseType.LogesticIdNotSpecifiedForaPostParcel]: LanguageKey.Notify_LogesticIdNotSpecifiedForaPostParcel,
    [ResponseType.LogesticNotInAvailableLogestics]: LanguageKey.Notify_LogesticNotInAvailableLogestics,
    [ResponseType.ExceedProductReportForLast24Hour]: LanguageKey.Notify_ExceedProductReportForLast24Hour,
    [ResponseType.PreviouslyReportedThisProduct]: LanguageKey.Notify_PreviouslyReportedThisProduct,
    [ResponseType.InvalidOrderId]: LanguageKey.Notify_InvalidOrderId,
    [ResponseType.NotPendingPayRequest]: LanguageKey.Notify_NotPendingPayRequest,
    [ResponseType.NotExistShopAddress]: LanguageKey.Notify_NotExistShopAddress,
    [ResponseType.InvalidOrderStatus]: LanguageKey.Notify_InvalidOrderStatus,
    [ResponseType.CancelInvoiceFailed]: LanguageKey.Notify_CancelInvoiceFailed,
    [ResponseType.PaymentSystemNotSupportedThisPriceType]: LanguageKey.Notify_PaymentSystemNotSupportedThisPriceType,
    [ResponseType.InvalidSentOrderType]: LanguageKey.Notify_InvalidSentOrderType,
    [ResponseType.InvalidParcelId]: LanguageKey.Notify_InvalidParcelId,
    [ResponseType.AddedParcelIdBefore]: LanguageKey.Notify_AddedParcelIdBefore,
    [ResponseType.InvoiceNotOnPaid]: LanguageKey.Notify_InvoiceNotOnPaid,
    [ResponseType.CreatedSystemTicketOnOrderBefore]: LanguageKey.Notify_CreatedSystemTicketOnOrderBefore,
    [ResponseType.PaymentServiceNotResponding]: LanguageKey.Notify_PaymentServiceNotResponding,
    [ResponseType.YouAreNotAdmin]: LanguageKey.Notify_YouAreNotAdmin,
    [ResponseType.YouAreNotASubAdmin]: LanguageKey.Notify_YouAreNotASubAdmin,
    [ResponseType.InvalidFbId]: LanguageKey.Notify_InvalidFbId,
    [ResponseType.InvalidFeatureId]: LanguageKey.Notify_InvalidFeatureId,
    [ResponseType.InActiveFeature]: LanguageKey.Notify_InActiveFeature,
    [ResponseType.FeaturePaused]: LanguageKey.Notify_FeaturePaused,
    [ResponseType.InvalidPromptInput]: LanguageKey.Notify_InvalidPromptInput,
    [ResponseType.PromptNotGenerated]: LanguageKey.Notify_PromptNotGenerated,
    [ResponseType.AIGeneratorFailed]: LanguageKey.Notify_AIGeneratorFailed,
    [ResponseType.NotExecutedPromptForCommentYet]: LanguageKey.Notify_NotExecutedPromptForCommentYet,
    [ResponseType.InstagramPermissionNotExist]: LanguageKey.Notify_InstagramPermissionNotExist,
    [ResponseType.InvalidTimeZone]: LanguageKey.Notify_InvalidTimeZone,
    [ResponseType.PromptCaptionExampleNotGenerated]: LanguageKey.Notify_PromptCaptionExampleNotGenerated,
    [ResponseType.InvalidMasterFlowId]: LanguageKey.Notify_InvalidMasterFlowId,
    [ResponseType.InvalidFlowId]: LanguageKey.Notify_InvalidFlowId,
    [ResponseType.EmptySubFlows]: LanguageKey.Notify_EmptySubFlows,
    [ResponseType.InvalidFlowObject]: LanguageKey.Notify_InvalidFlowObject,
    [ResponseType.InvalidMasterFlowTitle]: LanguageKey.Notify_InvalidMasterFlowTitle,
    [ResponseType.InvalidPromptId]: LanguageKey.Notify_InvalidPromptId,
    [ResponseType.ExceedThreadTokenLimit]: LanguageKey.Notify_ExceedThreadTokenLimit,
    [ResponseType.InvalidMediaId]: LanguageKey.Notify_InvalidMediaId,
    [ResponseType.InvalidLotteryId]: LanguageKey.Notify_InvalidLotteryId,
    [ResponseType.CannotAbortNonUpcomingLottery]: LanguageKey.Notify_CannotAbortNonUpcomingLottery,
    [ResponseType.CommentCountExceedFreeExport]: LanguageKey.Notify_CommentCountExceedFreeExport,
    [ResponseType.InvalidReserveFeatureId]: LanguageKey.Notify_InvalidReserveFeatureId,
    [ResponseType.CannotRenewalThisFeatureNow]: LanguageKey.Notify_CannotRenewalThisFeatureNow,
    [ResponseType.InvalidLotteryStatus]: LanguageKey.Notify_InvalidLotteryStatus,
    [ResponseType.PublishedLotteryBannerBefore]: LanguageKey.Notify_PublishedLotteryBannerBefore,
    [ResponseType.LotteryWinnerBannerIsNull]: LanguageKey.Notify_LotteryWinnerBannerIsNull,
    [ResponseType.InvalidCustomPromptSigniture]: LanguageKey.Notify_InvalidCustomPromptSigniture,
    [ResponseType.ServiceTemporarilyUnavailable]: LanguageKey.Notify_ServiceTemporarilyUnavailable,
    [ResponseType.PageSummaryNotGenerated]: LanguageKey.Notify_PageSummaryNotGenerated,
    [ResponseType.GenerateAIFail]: LanguageKey.Notify_GenerateAIFail,
    [ResponseType.InvalidPageAnalysis]: LanguageKey.Notify_InvalidPageAnalysis,
    [ResponseType.InvalidCustomPrompt]: LanguageKey.Notify_InvalidCustomPrompt,
    [ResponseType.AIModelNotSupportImage]: LanguageKey.Notify_AIModelNotSupportImage,
    [ResponseType.PromptNotSupportImage]: LanguageKey.Notify_PromptNotSupportImage,
    [ResponseType.AIModelNotSupportAudio]: LanguageKey.Notify_AIModelNotSupportAudio,
    [ResponseType.PromptNotSupportVoice]: LanguageKey.Notify_PromptNotSupportVoice,
    [ResponseType.AIModelNotSupportVideo]: LanguageKey.Notify_AIModelNotSupportVideo,
    [ResponseType.InvalidPrompt]: LanguageKey.Notify_InvalidPrompt,
    [ResponseType.InvalidImageGeneratorInput]: LanguageKey.Notify_InvalidImageGeneratorInput,
    [ResponseType.InSuffcientNumberOfImage]: LanguageKey.Notify_InSuffcientNumberOfImage,
    [ResponseType.CreateImageExceedLimit]: LanguageKey.Notify_CreateImageExceedLimit,
    [ResponseType.InvalidPromptType]: LanguageKey.Notify_InvalidPromptType,
    [ResponseType.UnSupportedAIInputType]: LanguageKey.Notify_UnSupportedAIInputType,
    [ResponseType.UnSupportedOrientationType]: LanguageKey.Notify_UnSupportedOrientationType,
    [ResponseType.SoraFailedAiCall]: LanguageKey.Notify_SoraFailedAiCall,
    [ResponseType.AIVideoSecondNotSupported]: LanguageKey.Notify_AIVideoSecondNotSupported,
    [ResponseType.FailedToTraslateDescription]: LanguageKey.Notify_FailedToTraslateDescription,
    [ResponseType.FailedToGenerateEmbedVector]: LanguageKey.Notify_FailedToGenerateEmbedVector,
    [ResponseType.NotGeneratedSummaryYet]: LanguageKey.Notify_NotGeneratedSummaryYet,
    [ResponseType.NoEventsFoundForTheGivenTimeRange]: LanguageKey.Notify_NoEventsFoundForTheGivenTimeRange,
    [ResponseType.NoEventsFoundForThisPrompt]: LanguageKey.Notify_NoEventsFoundForThisPrompt,
    [ResponseType.PageAnalysisNotExist]: LanguageKey.Notify_PageAnalysisNotExist,
    [ResponseType.NoEventIdeaGenerated]: LanguageKey.Notify_NoEventIdeaGenerated,
    [ResponseType.ThisCustomDomainCreatedBefore]: LanguageKey.Notify_ThisCustomDomainCreatedBefore,
    [ResponseType.ThisCustomDomainBelongsToAnother]: LanguageKey.Notify_ThisCustomDomainBelongsToAnother,
    [ResponseType.YouCustomDomainRequestedBeforeWaitATimeToRequestAgain]:
      LanguageKey.Notify_YouCustomDomainRequestedBeforeWaitATimeToRequestAgain,
    [ResponseType.LetsEncryptError]: LanguageKey.Notify_LetsEncryptError,
    [ResponseType.NoPendingCustomDomain]: LanguageKey.Notify_NoPendingCustomDomain,
    [ResponseType.YouCustomDomainCheckedBeforeWaitATimeToCheckAgain]:
      LanguageKey.Notify_YouCustomDomainCheckedBeforeWaitATimeToCheckAgain,
    [ResponseType.CustomDomainVerificationNotPassed]: LanguageKey.Notify_CustomDomainVerificationNotPassed,
    [ResponseType.InvalidProductTempId]: LanguageKey.Notify_InvalidProductTempId,
    [ResponseType.InvalidPriceType]: LanguageKey.Notify_InvalidPriceType,
    [ResponseType.AuthorizeCountryRequired]: LanguageKey.Notify_AuthorizeCountryRequired,
    [ResponseType.ProperyMustBeNumeric]: LanguageKey.Notify_ProperyMustBeNumeric,
    [ResponseType.PhoneNumberAddedBefore]: LanguageKey.Notify_PhoneNumberAddedBefore,
    [ResponseType.WhatsAppCodeSendedBeforeAndWait1Day]: LanguageKey.Notify_WhatsAppCodeSendedBeforeAndWait1Day,
    [ResponseType.WhatsAppCodeNotRequested]: LanguageKey.Notify_WhatsAppCodeNotRequested,
    [ResponseType.WhatsAppCodeMaxInvalidCountReach]: LanguageKey.Notify_WhatsAppCodeMaxInvalidCountReach,
    [ResponseType.UserWithThisPhoneNumberAlreadyExist]: LanguageKey.Notify_UserWithThisPhoneNumberAlreadyExist,
    [ResponseType.InvalidAIToolId]: LanguageKey.Notify_InvalidAIToolId,
    [ResponseType.AIToolParameterRequired]: LanguageKey.Notify_AIToolParameterRequired,
    [ResponseType.AIToolParameterNotRequired]: LanguageKey.Notify_AIToolParameterNotRequired,
    [ResponseType.ExceedDailyLimit]: LanguageKey.Notify_ExceedDailyLimit,
    [ResponseType.CannotGetTwitchRightNow]: LanguageKey.Notify_CannotGetTwitchRightNow,
    [ResponseType.InvalidTwitchChannelId]: LanguageKey.Notify_InvalidTwitchChannelId,
    [ResponseType.PhoneNumberRequired]: LanguageKey.Notify_PhoneNumberRequired,
    [ResponseType.NotVerifiedHost]: LanguageKey.Notify_NotVerifiedHost,
    [ResponseType.NotBusinesser]: LanguageKey.Notify_NotBusinesser,
    [ResponseType.NotFoundAnySuggestedCategory]: LanguageKey.Notify_NotFoundAnySuggestedCategory,
    [ResponseType.NoInvoiceExist]: LanguageKey.Notify_NoInvoiceExist,
    [ResponseType.InvalidMediaAiCreatorKey]: LanguageKey.Notify_InvalidMediaAiCreatorKey,
    [ResponseType.InvalidMediaAiVersionKey]: LanguageKey.Notify_InvalidMediaAiVersionKey,
    [ResponseType.InvalidMediaAiRequestModel]: LanguageKey.Notify_InvalidMediaAiRequestModel,
    [ResponseType.MediaAIError]: LanguageKey.Notify_MediaAIError,
    [ResponseType.TwitchChannelDoestHaveAnyVideo]: LanguageKey.Notify_TwitchChannelDoestHaveAnyVideo,
    [ResponseType.CouponAlreadyDeleted]: LanguageKey.Notify_CouponAlreadyDeleted,
    [ResponseType.CouponNotDeleted]: LanguageKey.Notify_CouponNotDeleted,
    [ResponseType.ExceedSubFlowCount]: LanguageKey.Notify_ExceedSubFlowCount,
    [ResponseType.ExceedFlowDepth]: LanguageKey.Notify_ExceedFlowDepth,
    [ResponseType.ExceedFlowItemCount]: LanguageKey.Notify_ExceedFlowItemCount,
    [ResponseType.ExceedFlowMediaAudioCount]: LanguageKey.Notify_ExceedFlowMediaAudioCount,
    [ResponseType.OneFlowButtonHasEmptyItem]: LanguageKey.Notify_OneFlowButtonHasEmptyItem,
  };

  const languageKey = responseTextMap[responseType];
  if (languageKey) {
    return `${t(languageKey)} - (#${1000 + responseType})`;
  }
  return `${t(LanguageKey.Notify_Unexpected)} - (#${1000 + responseType})`;
};

export function notify(responseType: ResponseType, type: NotifType, customMsg?: string) {
  const message = getResponseTextLegacy(responseType);
  const toastId = `notify-${responseType}-${type}`;
  if (type === NotifType.Error) {
    toast.error(customMsg ? message + customMsg : message, { toastId });
  } else if (type === NotifType.Warning) {
    toast.warn(customMsg ? message + customMsg : message, { toastId });
  } else if (type === NotifType.Info) {
    toast.info(customMsg ? message + customMsg : message, { toastId });
  } else if (type === NotifType.Success) {
    toast.success(customMsg ? message + customMsg : message, { toastId });
  }
}

// Custom hook for notification with translation
export function useNotify() {
  const { t } = useTranslation();

  return (responseType: ResponseType, type: NotifType, customMsg?: string) => {
    const message = getResponseText(responseType, t);
    const toastId = `notify-${responseType}-${type}`;
    if (type === NotifType.Error) {
      toast.error(customMsg ? message + customMsg : message, { toastId });
    } else if (type === NotifType.Warning) {
      toast.warn(customMsg ? message + customMsg : message, { toastId });
    } else if (type === NotifType.Info) {
      toast.info(customMsg ? message + customMsg : message, { toastId });
    } else if (type === NotifType.Success) {
      toast.success(customMsg ? message + customMsg : message, { toastId });
    }
  };
}

export function notify2(responseType: ResponseType, type: NotifType, customMsg?: string) {
  const { t } = useTranslation();
  const message = getEnumValue(ResponseType, LanguageKey, responseType);
  if (!message) return;
  const toastId = `notify2-${responseType}-${type}`;
  if (type === NotifType.Error) {
    toast.error(customMsg ? t(message) + customMsg : t(message), { toastId });
  } else if (type === NotifType.Warning) {
    toast.warn(customMsg ? t(message) + customMsg : t(message), { toastId });
  } else if (type === NotifType.Info) {
    toast.info(customMsg ? t(message) + customMsg : t(message), { toastId });
  } else if (type === NotifType.Success) {
    toast.success(customMsg ? t(message) + customMsg : t(message), { toastId });
  }
}
// Helper function to get translated internal response text
const getInternalResponseText = (responseType: InternalResponseType, t: (key: LanguageKey) => string): string => {
  const internalResponseTextMap: Record<InternalResponseType, LanguageKey> = {
    [InternalResponseType.Ok]: LanguageKey.InternalNotify_Ok,
    [InternalResponseType.RepetitiveHashtagInput]: LanguageKey.InternalNotify_RepetitiveHashtagInput,
    [InternalResponseType.NotFoundDevice]: LanguageKey.InternalNotify_NotFoundDevice,
    [InternalResponseType.EmptyHashtagList]: LanguageKey.InternalNotify_EmptyHashtagList,
    [InternalResponseType.CannotCreatePrePostNow]: LanguageKey.InternalNotify_CannotCreatePrePostNow,
    [InternalResponseType.PrivateAccountSelectedForCheckHashtag]:
      LanguageKey.InternalNotify_PrivateAccountSelectedForCheckHashtag,
    [InternalResponseType.InstagramLoginRequired]: LanguageKey.InternalNotify_InstagramLoginRequired,
    [InternalResponseType.InstagramLoginRequiredForVerifiedAccount]:
      LanguageKey.InternalNotify_InstagramLoginRequiredForVerifiedAccount,
    [InternalResponseType.PrivateOrVerifiedSponsor]: LanguageKey.InternalNotify_PrivateOrVerifiedSponsor,
    [InternalResponseType.InstagramLoginRequiredForPrivateAccount]:
      LanguageKey.InternalNotify_InstagramLoginRequiredForPrivateAccount,
    [InternalResponseType.StartUploadingPost]: LanguageKey.InternalNotify_StartUploadingPost,
    [InternalResponseType.UploadingPostError]: LanguageKey.InternalNotify_UploadingPostError,
    [InternalResponseType.PostUploaded]: LanguageKey.InternalNotify_PostUploaded,
    [InternalResponseType.ExceededMedia]: LanguageKey.InternalNotify_ExceededMedia,
    [InternalResponseType.More4IceBreaker]: LanguageKey.InternalNotify_More4IceBreaker,
    [InternalResponseType.CopyLink]: LanguageKey.InternalNotify_CopyLink,
    [InternalResponseType.copy]: LanguageKey.InternalNotify_copy,
    [InternalResponseType.CopyTrackingpost]: LanguageKey.InternalNotify_CopyTrackingpost,
    [InternalResponseType.Network]: LanguageKey.InternalNotify_Network,
    [InternalResponseType.TimeExpire]: LanguageKey.InternalNotify_TimeExpire,
    [InternalResponseType.ExceedPermittedHashtagNumber]: LanguageKey.InternalNotify_ExceedPermittedHashtagNumber,
    [InternalResponseType.ExceedPermittedUploadMedia]: LanguageKey.InternalNotify_ExceedPermittedUploadMedia,
    [InternalResponseType.UnexpectedError]: LanguageKey.InternalNotify_UnexpectedError,
    [InternalResponseType.CopyToClipboard]: LanguageKey.InternalNotify_CopyToClipboard,
    [InternalResponseType.FillRedBorderFields]: LanguageKey.InternalNotify_FillRedBorderFields,
    [InternalResponseType.RepeatedVariation]: LanguageKey.InternalNotify_RepeatedVariation,
    [InternalResponseType.NeedOneProduct]: LanguageKey.InternalNotify_NeedOneProduct,
    [InternalResponseType.UploadMedia]: LanguageKey.InternalNotify_UploadMedia,
    [InternalResponseType.TurnOnProxy]: LanguageKey.InternalNotify_TurnOnProxy,
    [InternalResponseType.ExceedPermittedLiveTime]: LanguageKey.InternalNotify_ExceedPermittedLiveTime,
    [InternalResponseType.CommentDisabled]: LanguageKey.InternalNotify_CommentDisabled,
    [InternalResponseType.ExceedSelectedCollaboratorPage]: LanguageKey.InternalNotify_ExceedSelectedCollaboratorPage,
    [InternalResponseType.RepetitiveCollaboratorPage]: LanguageKey.InternalNotify_RepetitiveCollaboratorPage,
    [InternalResponseType.ExceedPermittedSizeOfImage]: LanguageKey.InternalNotify_ExceedPermittedSizeOfImage,
    [InternalResponseType.ExceedPermittedAspectRatioAlbum]: LanguageKey.InternalNotify_ExceedPermittedAspectRatioAlbum,
    [InternalResponseType.ExceedPermittedSizeOfVideoAlbum]: LanguageKey.InternalNotify_ExceedPermittedSizeOfVideoAlbum,
    [InternalResponseType.ExceedPermittedDurationOfVideoAlbum]:
      LanguageKey.InternalNotify_ExceedPermittedDurationOfVideoAlbum,
    [InternalResponseType.ExceedPermittedAspectRatioReels]: LanguageKey.InternalNotify_ExceedPermittedAspectRatioReels,
    [InternalResponseType.ExceedPermittedSizeOfVideoReels]: LanguageKey.InternalNotify_ExceedPermittedSizeOfVideoReels,
    [InternalResponseType.ExceedPermittedDurationOfVideoReels]:
      LanguageKey.InternalNotify_ExceedPermittedDurationOfVideoReels,
    [InternalResponseType.NotPermittedMediaType]: LanguageKey.InternalNotify_NotPermittedMediaType,
    [InternalResponseType.InvalidMetaData]: LanguageKey.InternalNotify_InvalidMetaData,
    [InternalResponseType.ExceedSelectedMaxTaggedPeople]: LanguageKey.InternalNotify_ExceedSelectedMaxTaggedPeople,
    [InternalResponseType.ExceedSelectedMaxHashtags]: LanguageKey.InternalNotify_ExceedSelectedMaxHashtags,
    [InternalResponseType.ExistedInCollaborate]: LanguageKey.InternalNotify_ExistedInCollaborate,
    [InternalResponseType.ExceedPermittedAspectRatioStory]: LanguageKey.InternalNotify_ExceedPermittedAspectRatioStory,
    [InternalResponseType.ExceedPermittedSizeOfVideoStory]: LanguageKey.InternalNotify_ExceedPermittedSizeOfVideoStory,
    [InternalResponseType.ExceedPermittedWidthOfVideo]: LanguageKey.InternalNotify_ExceedPermittedWidthOfVideo,
    [InternalResponseType.ExceedPermittedDurationOfVideoStory]:
      LanguageKey.InternalNotify_ExceedPermittedDurationOfVideoStory,
    [InternalResponseType.BelowMinimumDurationOfVideoStory]:
      LanguageKey.InternalNotify_BelowMinimumDurationOfVideoStory,
    [InternalResponseType.ExceedPermittedSpecificWordForAutoreply]:
      LanguageKey.InternalNotify_ExceedPermittedSpecificWordForAutoreply,
    [InternalResponseType.ExceedPermittedAspectRatioImage]: LanguageKey.InternalNotify_ExceedPermittedAspectRatioImage,
    [InternalResponseType.Success]: LanguageKey.InternalNotify_Success,
    [InternalResponseType.CreateExportAvailableWith24HourPeriod]:
      LanguageKey.InternalNotify_CreateExportAvailableWith24HourPeriod,
    [InternalResponseType.SaveIceBreaker]: LanguageKey.InternalNotify_SaveIceBreaker,
    [InternalResponseType.deleteIceBreaker]: LanguageKey.InternalNotify_deleteIceBreaker,
    [InternalResponseType.SavePersistenceMenu]: LanguageKey.InternalNotify_SavePersistenceMenu,
    [InternalResponseType.SelectLanguage]: LanguageKey.InternalNotify_SelectLanguage,
    [InternalResponseType.SaveFollowTemplate]: LanguageKey.InternalNotify_SaveFollowTemplate,
    [InternalResponseType.AutoReplyOn]: LanguageKey.InternalNotify_AutoReplyOn,
    [InternalResponseType.AutoReplyOff]: LanguageKey.InternalNotify_AutoReplyOff,
    [InternalResponseType.AutoGeneralOn]: LanguageKey.InternalNotify_AutoGeneralOn,
    [InternalResponseType.AutoGeneralOff]: LanguageKey.InternalNotify_AutoGeneralOff,
    [InternalResponseType.MaxInEachCard]: LanguageKey.InternalNotify_MaxInEachCard,
    [InternalResponseType.ExceedStockCard]: LanguageKey.InternalNotify_ExceedStockCard,
    [InternalResponseType.DefaultAddress]: LanguageKey.InternalNotify_DefaultAddress,
    [InternalResponseType.FetchingYourData]: LanguageKey.InternalNotify_FetchingYourData,
    [InternalResponseType.EmptyTitleInQuickReply]: LanguageKey.InternalNotify_EmptyTitleInQuickReply,
    [InternalResponseType.EmptyTitleForOutputsInQuickReply]:
      LanguageKey.InternalNotify_EmptyTitleForOutputsInQuickReply,
    [InternalResponseType.EmptyTitleForFlow]: LanguageKey.InternalNotify_EmptyTitleForFlow,
    [InternalResponseType.MultipleFlowForPrivateReply]: LanguageKey.InternalNotify_MultipleFlowForPrivateReply,
    [InternalResponseType.NotPermittedForDownload]: LanguageKey.InternalNotify_NotPermittedForDownload,
    [InternalResponseType.NotFeature]: LanguageKey.InternalNotify_NotFeature,
    [InternalResponseType.ExceedBasefeatureTime]: LanguageKey.InternalNotify_ExceedBasefeatureTime,
    [InternalResponseType.ChannelIdNotStartedWithUC]: LanguageKey.InternalNotify_ChannelIdNotStartedWithUC,
    [InternalResponseType.PageAnalysisNotCompleted]: LanguageKey.InternalNotify_PageAnalysisNotCompleted,
  };

  const languageKey = internalResponseTextMap[responseType];
  if (languageKey) {
    return `${t(languageKey)} - (#${2000 + responseType})`;
  }
  return `${t(LanguageKey.Notify_Unexpected)} - (#${2000 + responseType})`;
};

export function internalNotify(responseType: InternalResponseType, type: NotifType, customMsg?: string) {
  const message = getInternalResponseTextLegacy(responseType);
  const toastId = `internal-notify-${responseType}-${type}`;
  if (type === NotifType.Error) {
    toast.error(customMsg ? message + customMsg : message, { toastId });
  } else if (type === NotifType.Warning) {
    toast.warn(customMsg ? message + customMsg : message, { toastId });
  } else if (type === NotifType.Info) {
    toast.info(customMsg ? message + customMsg : message, { toastId });
  } else if (type === NotifType.Success) {
    toast.success(customMsg ? message + customMsg : message, { toastId });
  }
}

// Custom hook for internal notification with translation
export function useInternalNotify() {
  const { t } = useTranslation();

  return (responseType: InternalResponseType, type: NotifType, customMsg?: string) => {
    const message = getInternalResponseText(responseType, t);
    const toastId = `internal-notify-${responseType}-${type}`;
    if (type === NotifType.Error) {
      toast.error(customMsg ? message + customMsg : message, { toastId });
    } else if (type === NotifType.Warning) {
      toast.warn(customMsg ? message + customMsg : message, { toastId });
    } else if (type === NotifType.Info) {
      toast.info(customMsg ? message + customMsg : message, { toastId });
    } else if (type === NotifType.Success) {
      toast.success(customMsg ? message + customMsg : message, { toastId });
    }
  };
}

export function notPackageNotify() {
  toast.error("no package", {
    autoClose: 50000000,
  });
}
const Notification = () => {
  return (
    <div>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Slide}
        limit={3}
        stacked
      />
    </div>
  );
};
export enum NotifType {
  Success = 0,
  Info = 1,
  Warning = 2,
  Error = 3,
}
export enum ResponseType {
  Ok,
  InternalException,
  CannotSendSmsNow,
  InvalidPhoneNumber,
  InvalidCountryCode,
  PhoneNumberNotAvailableInThisCountry,
  InstagramerIdNotExist,
  EmptyProductList,
  InvalidVerificationCode,
  LowQuality,
  CannotEmptyChildren,
  InvalidAspectRatio,
  InvalidMediaCodec,
  InvalidMediaType,
  MediaUrlNotAccessible,
  CannotCreatePrePostNow,
  InvalidMediaContent,
  Unexpected,
  TooManyRequestForImageHashtagGenerator,
  LoginFailed,
  NullUserId,
  RealtimeSocketNotExist,
  PushSocketNotExist,
  InstaApiNotFoundForConnect,
  EmptyHashtagList,
  InvalidHashtagListId,
  DeleteHashtagFail,
  InvalidBase64Content,
  InvalidTermsAndConditionSvgType,
  InvalidLotteryAnnouncementBannerId,
  InvalidLotteryAnnouncementBannerStr,
  InvalidPostId,
  TooSoonLotteryInfo,
  InvalidDirectParams,
  NoInstagramerExists,
  PropertyNotFoundOrNull,
  ReachNumberOfPinDirect,
  InvalidStoryId,
  MaxPrePostReach,
  InvalidDraftId,
  InvalidPrePostId,
  ReachHashtagListLimit,
  EmptyUsername,
  TooManyRequestForPageHashtagAnalysis,
  PasswordRequired,
  PackageRequiredInThisTime,
  FeatureRequiredInThisTime,
  NoShopperExist,
  FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount,
  FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount,
  InvalidLinkId,
  ReachMaxBioLink,
  OnlyBusinessAccountHasThisAccess,
  NoYoutubeChannelFound,
  CannotGetYoutubeRightNow,
  AparatUsernameNotFound,
  AparatChannelHasNotAnyVideo,
  InvalidYoutubeChannelId,
  NoAparatChannelFound,
  CannotGetAparatRightNow,
  NotSettedCustomDomain,
  CannotStoryWithoutWinnerBanner,
  ExceedMaxStoryWinnerLotteryBanner,
  LotteryOnProcessingOrEnded,
  CannotAbortLotteryOneHourBefore,
  CannotAbortFollowerLottery,
  InvalidImageOrExceedMaxSize,
  ExceedLoginAttempt,
  NotExistComment,
  UserNotFound,
  ExistInstagramerBefore,
  CannotChangeBusinessAccountType,
  InvalidProductId,
  InvalidTrendHashtagPeriod,
  InvalidLanguageId,
  CannotStoryWithoutTermsBanner,
  ExceedMaxStoryTermsLotteryBanner,
  LotteryTermsIsNull,
  CanShareTermsBefore6HoursOfStartLottery,
  CanShareTermForOnlyDefinedStatusLotteries,
  SharedRemainingTimeBefore,
  ShareRemainingTimeOnlyActiveForScoreLottery,
  CanShareTermsBefore1HoursOfStartLottery,
  InvalidSubProductIds,
  ReachMaxProductMedia,
  InvalidMediaProductId,
  AccountNotABusiness,
  NotFoundProductWithThisTempId,
  InvalidAvailabilityStatus,
  InvalidIbanNumber,
  ExistedIbanNumber,
  IbanMethodNotAvailableForNotTomanPriceUser,
  SearchQueryIsEmpty,
  ExceedMaxInEachCard,
  ProductNotAlbumPost,
  InvalidChildrenId,
  NotAvailableProduct,
  ExceedStockCount,
  CannotUnloadAnInstanceProduct,
  InvalidCategoryId,
  NotFoundAnyProductOnThisCategory,
  NotFoundAnyNextProduct,
  NotFoundAnyPreviousProduct,
  InvalidItemId,
  IpInvalid,
  ThisInstagramAccountAddedBefore,
  InvalidTicketId,
  ExpiredSignature,
  Forbidden,
  ConnectedInstagramPageNotFound,
  AllInstagramAccountConnectedAddedBefore,
  SelectInstagramPageToConnect,
  InstagramRedirectRoleNotFound,
  FacebookLoginNotFound,
  SelectedPageNotFound,
  ShouldConnectInstaPageAgain,
  InvalidProductSuggestionId,
  NotSavedSuggestions,
  ExistedSuggestedMedia,
  InvalidUploadMediaUrl,
  SuggestedPostAutoReplyKeyNotExist,
  UploadingTimeIsSoSoon,
  InvalidPreStoryId,
  NotProvidedInstagramerId,
  InvalidInstagramerId,
  InvalidThreadId,
  InvalidLiveMediaId,
  NotCreatedExportComment,
  CreateExportAvailableWith24HourPeriod,
  NotSetted,
  ExceedGeneralAutoReplyCount,
  InvalidTransactionId,
  CannotRenewalPackageWith1MonthTimeExist,
  CannotDeleteCurrentSession,
  InvalidSessionId,
  CannotDeleteCurrentSessionForNewSessionFor1Day,
  UpgradedBefore,
  PermissionNotExist,
  NotExistUser,
  UserAlreadyAsPartner,
  ReachMaxPartnerCount,
  InvalidPartnerRoleProvided,
  PartnerRolesLengthIsZero,
  PartnerNotExist,
  CannotMakeYourSelfPartnerAsPartnerForYourSelf,
  PartnerExpireTimeMustBeBiggerThan1HourFromNow,
  PartnerNameCannotExceed100,
  ProductIsMultiSubproducted,
  InvalidSubProductId,
  ProductIdOutOfStock,
  SubProductIdRequired,
  CardIsEmpty,
  InvalidAddressId,
  ExceedTotalCreateAddress,
  NotSupportedCountry,
  CannotFetchAddressInThisEndpoint,
  InvalidPostalCode,
  NeedCompleteAddress,
  CannotBuyFromYourSelf,
  AllReadyIsBusiness,
  InvalidBusinessType,
  UserAlreadyAuthorized,
  InstagramerNotInfluencer,
  InstagramerNotShopper,
  AuthorizedInstagramerBefore,
  UserNotAuthorizedYet,
  InstagramerNotAuthorized,
  InvalidBankCardNumber,
  TheOwnerOfPhoneNumberNotBlongsNationalNumber,
  CouponCodeAlreadyExists,
  InvalidCouponId,
  CannotChangeShowPrivateCouponInBio,
  InvalidCouponCode,
  CouponForAnotherPerson,
  CouponExpired,
  CouponDeleted,
  CouponUsedUp,
  InvalidUsernameSearchQuery,
  PreviouslyAddedShopAddress,
  NotSettedShopperAddress,
  NotExistAnyLogesticInYourCountry,
  InvalidLogesticIds,
  LogsticsNotSetted,
  NotCommpletedAllBusinessVerification,
  ThisParcelNotSupportedByAnySelectedAvailableLogestic,
  NotSupportedLogestic,
  ExceedLogesticHeight,
  ExceedLogesticWidth,
  ExceedLogesticLength,
  ExceedLogesticTotalLength,
  ExceedLogesticWeight,
  UserAddressesIsEmptyOrNotSetDefaultAddress,
  NotSupportedBoxByThisDimensions,
  CannotAvailableOutOfStackProduct,
  YouAreDeadInCivilRegistration,
  InstagramerAlreadyAuthorized,
  ThreadShouldBeActiveForSendMessage,
  PreviouslyClosedTicket,
  NotMatchedCart,
  PhoneNumberNotBlongsNationalNumber,
  NotMatchedCardNumberAndIdentity,
  SuspendedShop,
  LogesticIdNotSpecifiedForaPostParcel,
  LogesticNotInAvailableLogestics,
  ExceedProductReportForLast24Hour,
  PreviouslyReportedThisProduct,
  InvalidOrderId,
  NotPendingPayRequest,
  NotExistShopAddress,
  InvalidOrderStatus,
  CancelInvoiceFailed,
  PaymentSystemNotSupportedThisPriceType,
  InvalidSentOrderType,
  InvalidParcelId,
  AddedParcelIdBefore,
  InvoiceNotOnPaid,
  CreatedSystemTicketOnOrderBefore,
  PaymentServiceNotResponding,
  YouAreNotAdmin,
  YouAreNotASubAdmin,
  InvalidFbId,
  InvalidFeatureId,
  InActiveFeature,
  FeaturePaused,
  InvalidPromptInput,
  PromptNotGenerated,
  AIGeneratorFailed,
  NotExecutedPromptForCommentYet,
  InstagramPermissionNotExist,
  InvalidTimeZone,
  PromptCaptionExampleNotGenerated,
  InvalidMasterFlowId,
  InvalidFlowId,
  EmptySubFlows,
  InvalidFlowObject,
  InvalidMasterFlowTitle,
  InvalidPromptId,
  ExceedThreadTokenLimit,
  InvalidMediaId,
  InvalidLotteryId,
  CannotAbortNonUpcomingLottery,
  CommentCountExceedFreeExport,
  InvalidReserveFeatureId,
  CannotRenewalThisFeatureNow,
  InvalidLotteryStatus,
  PublishedLotteryBannerBefore,
  LotteryWinnerBannerIsNull,
  InvalidCustomPromptSigniture,
  ServiceTemporarilyUnavailable,
  PageSummaryNotGenerated,
  GenerateAIFail,
  InvalidPageAnalysis,
  InvalidCustomPrompt,
  AIModelNotSupportImage,
  PromptNotSupportImage,
  AIModelNotSupportAudio,
  PromptNotSupportVoice,
  AIModelNotSupportVideo,
  InvalidPrompt,
  InvalidImageGeneratorInput,
  InSuffcientNumberOfImage,
  CreateImageExceedLimit,
  InvalidPromptType,
  UnSupportedAIInputType,
  UnSupportedOrientationType,
  SoraFailedAiCall,
  AIVideoSecondNotSupported,
  FailedToTraslateDescription,
  FailedToGenerateEmbedVector,
  NotGeneratedSummaryYet,
  NoEventsFoundForTheGivenTimeRange,
  NoEventsFoundForThisPrompt,
  PageAnalysisNotExist,
  NoEventIdeaGenerated,
  ThisCustomDomainCreatedBefore,
  ThisCustomDomainBelongsToAnother,
  YouCustomDomainRequestedBeforeWaitATimeToRequestAgain,
  LetsEncryptError,
  NoPendingCustomDomain,
  YouCustomDomainCheckedBeforeWaitATimeToCheckAgain,
  CustomDomainVerificationNotPassed,
  InvalidProductTempId,
  InvalidPriceType,
  AuthorizeCountryRequired,
  ProperyMustBeNumeric,
  PhoneNumberAddedBefore,
  WhatsAppCodeSendedBeforeAndWait1Day,
  WhatsAppCodeNotRequested,
  WhatsAppCodeMaxInvalidCountReach,
  UserWithThisPhoneNumberAlreadyExist,
  InvalidAIToolId,
  AIToolParameterRequired,
  AIToolParameterNotRequired,
  ExceedDailyLimit,
  CannotGetTwitchRightNow,
  InvalidTwitchChannelId,
  PhoneNumberRequired,
  NotVerifiedHost,
  NotBusinesser,
  NotFoundAnySuggestedCategory,
  NoInvoiceExist,
  InvalidMediaAiCreatorKey,
  InvalidMediaAiVersionKey,
  InvalidMediaAiRequestModel,
  MediaAIError,
  TwitchChannelDoestHaveAnyVideo,
  CouponAlreadyDeleted,
  CouponNotDeleted,
  ExceedSubFlowCount,
  ExceedFlowDepth,
  ExceedFlowItemCount,
  ExceedFlowMediaAudioCount,
  OneFlowButtonHasEmptyItem,
}
export enum InternalResponseType {
  Ok = 0,
  RepetitiveHashtagInput = 1,
  NotFoundDevice = 2,
  EmptyHashtagList = 3,
  CannotCreatePrePostNow = 4,
  PrivateAccountSelectedForCheckHashtag = 5,
  InstagramLoginRequired = 6,
  InstagramLoginRequiredForVerifiedAccount = 7,
  PrivateOrVerifiedSponsor = 8,
  InstagramLoginRequiredForPrivateAccount = 9,
  StartUploadingPost = 10,
  UploadingPostError = 11,
  PostUploaded = 12,
  ExceededMedia = 13,
  More4IceBreaker = 14,
  CopyLink = 15,
  copy,
  CopyTrackingpost,
  Network = 31,
  TimeExpire,
  ExceedPermittedHashtagNumber,
  ExceedPermittedUploadMedia,
  UnexpectedError,
  CopyToClipboard,
  FillRedBorderFields,
  RepeatedVariation,
  NeedOneProduct,
  UploadMedia,
  TurnOnProxy,
  ExceedPermittedLiveTime,
  CommentDisabled,
  ExceedSelectedCollaboratorPage,
  RepetitiveCollaboratorPage,
  ExceedPermittedSizeOfImage,
  ExceedPermittedAspectRatioAlbum,
  ExceedPermittedSizeOfVideoAlbum,
  ExceedPermittedDurationOfVideoAlbum,
  ExceedPermittedAspectRatioReels,
  ExceedPermittedSizeOfVideoReels,
  ExceedPermittedDurationOfVideoReels,
  NotPermittedMediaType,
  InvalidMetaData,
  ExceedSelectedMaxTaggedPeople,
  ExceedSelectedMaxHashtags,
  ExistedInCollaborate,
  ExceedPermittedAspectRatioStory,
  ExceedPermittedSizeOfVideoStory,
  ExceedPermittedWidthOfVideo,
  ExceedPermittedDurationOfVideoStory,
  BelowMinimumDurationOfVideoStory,
  ExceedPermittedSpecificWordForAutoreply,
  ExceedPermittedAspectRatioImage,
  Success,
  CreateExportAvailableWith24HourPeriod,
  SaveIceBreaker,
  deleteIceBreaker,
  SavePersistenceMenu,
  SelectLanguage,
  SaveFollowTemplate,
  AutoReplyOn,
  AutoReplyOff,
  AutoGeneralOn,
  AutoGeneralOff,
  MaxInEachCard,
  ExceedStockCard,
  DefaultAddress,
  FetchingYourData,
  EmptyTitleInQuickReply,
  EmptyTitleForOutputsInQuickReply,
  EmptyTitleForFlow,
  MultipleFlowForPrivateReply,
  NotPermittedForDownload,
  NotFeature,
  ExceedBasefeatureTime,
  ChannelIdNotStartedWithUC,
  PageAnalysisNotCompleted,
}
export default Notification;
